export const LOAD_REPORT = `LOAD_REPORT`;
export const LOAD_PROJECTS = `LOAD_PROJECTS`;
export const LOAD_PROJECTS_ID_NAME = `LOAD_PROJECTS_ID_NAME`;

export const LOAD_TASK = `LOAD_TASK`;
export const LOAD_TASKS = `LOAD_TASKS`;
export const LOAD_USER = `LOAD_USER`;
export const LOAD_USERS = `LOAD_USERS`;
export const LOAD_TEAM = `LOAD_TEAM`;
export const LOAD_TEAMS = `LOAD_TEAMS`;
export const LOAD_CONFIG_OPTIONS = `LOAD_CONFIG_OPTIONS`;
export const LOAD_LOGGED_USER = `LOAD_LOGGED_USER`;
export const LOAD_REQUEST = `LOAD_REQUEST`;
export const LOAD_FAILURE = `LOAD_FAILURE`;
export const FETCH_TEAM_TASKS_LOADING = `FETCH_TEAM_TASKS_LOADING`;
export const FETCH_TEAM_TASKS_SUCCESS = `FETCH_TEAM_TASKS_SUCCESS`;
export const FETCH_TEAM_TASKS_ERROR = `FETCH_TEAM_TASKS_ERROR`;

// PROJECTS
export const ADD_PROJECT_LOADING = `ADD_PROJECT_LOADING`;
export const ADD_PROJECT_SUCCESS = `ADD_PROJECT_SUCCESS`;
export const ADD_PROJECT_ERROR = `ADD_PROJECT_ERROR`;
export const ADD_PROJECT_FROM_DATASET_LOADING = `ADD_PROJECT_FROM_DATASET_LOADING`;
export const ADD_PROJECT_FROM_DATASET_SUCCESS = `ADD_PROJECT_FROM_DATASET_SUCCESS`;
export const ADD_PROJECT_FROM_DATASET_ERROR = `ADD_PROJECT_FROM_DATASET_ERROR`;
export const EDIT_PROJECT_LOADING = `EDIT_PROJECT_LOADING`;
export const EDIT_PROJECT_SUCCESS = `EDIT_PROJECT_SUCCESS`;
export const EDIT_PROJECT_ERROR = `EDIT_PROJECT_ERROR`;
export const FETCH_PROJECT_LOADING = `FETCH_PROJECT_LOADING`;
export const FETCH_PROJECT_SUCCESS = `FETCH_PROJECT_SUCCESS`;
export const FETCH_PROJECT_ERROR = `FETCH_PROJECT_ERROR`;
export const FETCH_PROJECTS_LOADING = `FETCH_PROJECTS_LOADING`;
export const FETCH_PROJECTS_SUCCESS = `FETCH_PROJECTS_SUCCESS`;
export const FETCH_PROJECTS_ERROR = `FETCH_PROJECTS_ERROR`;
export const DUPLICATE_PROJECT_LOADING = `DUPLICATE_PROJECT_LOADING`;
export const DUPLICATE_PROJECT_SUCCESS = `DUPLICATE_PROJECT_SUCCESS`;
export const DUPLICATE_PROJECT_ERROR = `DUPLICATE_PROJECT_ERROR`;
export const FETCH_COMPANY_PROJECTS_LOADING = `FETCH_COMPANY_PROJECTS_LOADING`;
export const FETCH_COMPANY_PROJECTS_SUCCESS = `FETCH_COMPANY_PROJECTS_SUCCESS`;
export const FETCH_COMPANY_PROJECTS_ERROR = `FETCH_COMPANY_PROJECTS_ERROR`;
export const FETCH_PROJECTS_FOR_SCREEN_LOADING = `FETCH_PROJECTS_FOR_SCREEN_LOADING`;
export const FETCH_PROJECTS_FOR_SCREEN_SUCCESS = `FETCH_PROJECTS_FOR_SCREEN_SUCCESS`;
export const FETCH_PROJECTS_FOR_SCREEN_ERROR = `FETCH_PROJECTS_FOR_SCREEN_ERROR`;
export const FETCH_CLOSED_PROJECTS_LOADING = `FETCH_CLOSED_PROJECTS_LOADING`;
export const FETCH_CLOSED_PROJECTS_SUCCESS = `FETCH_CLOSED_PROJECTS_SUCCESS`;
export const FETCH_CLOSED_PROJECTS_ERROR = `FETCH_CLOSED_PROJECTS_ERROR`;
export const ADD_MEMBERS_TO_PROJECT_LOADING = `ADD_MEMBERS_TO_PROJECT_LOADING`;
export const ADD_MEMBERS_TO_PROJECT_SUCCESS = `ADD_MEMBERS_TO_PROJECT_SUCCESS`;
export const ADD_MEMBERS_TO_PROJECT_ERROR = `ADD_MEMBERS_TO_PROJECT_ERROR`;
export const REMOVE_MEMBER_FROM_PROJECT_LOADING = `REMOVE_MEMBER_FROM_PROJECT_LOADING`;
export const REMOVE_MEMBER_FROM_PROJECT_SUCCESS = `REMOVE_MEMBER_FROM_PROJECT_SUCCESS`;
export const REMOVE_MEMBER_FROM_PROJECT_ERROR = `REMOVE_MEMBER_FROM_PROJECT_ERROR`;
export const REPLACE_MEMBER_ON_PROJECT_LOADING = `REPLACE_MEMBER_ON_PROJECT_LOADING`;
export const REPLACE_MEMBER_ON_PROJECT_SUCCESS = `REPLACE_MEMBER_ON_PROJECT_SUCCESS`;
export const REPLACE_MEMBER_ON_PROJECT_ERROR = `REPLACE_MEMBER_ON_PROJECT_ERROR`;
export const PROJECT_MEMBERSHIP_GRANTED_FROM_EVENT_STREAM = `PROJECT_MEMBERSHIP_GRANTED_FROM_EVENT_STREAM`;
export const PROJECT_MEMBERSHIP_REVOKED_FROM_EVENT_STREAM = `PROJECT_MEMBERSHIP_REVOKED_FROM_EVENT_STREAM`;
export const ADD_PROJECT_FROM_EVENT_STREAM_SUCCESS = `ADD_PROJECT_FROM_EVENT_STREAM_SUCCESS`;
export const EDIT_PROJECT_FROM_EVENT_STREAM_SUCCESS = `EDIT_PROJECT_FROM_EVENT_STREAM_SUCCESS`;
export const PROJECT_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS = `PROJECT_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS`;
export const PROJECT_COMPLETED_FROM_EVENT_STREAM_SUCCESS = `PROJECT_COMPLETED_FROM_EVENT_STREAM_SUCCESS`;
export const PROJECT_REOPENED_FROM_EVENT_STREAM_SUCCESS = `PROJECT_REOPENED_FROM_EVENT_STREAM_SUCCESS`;
export const PROJECT_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS = `PROJECT_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS`;
export const FETCH_PROJECTS_BUDGETING_DATA_LOADING = "FETCH_PROJECTS_BUDGETING_DATA_LOADING";
export const FETCH_PROJECTS_BUDGETING_DATA_SUCCESS = "FETCH_PROJECTS_BUDGETING_DATA_SUCCESS";
export const FETCH_PROJECTS_BUDGETING_DATA_ERROR = "FETCH_PROJECTS_BUDGETING_DATA_ERROR";
export const BATCH_EDIT_BUDGET_TYPES_LOADING = "BATCH_EDIT_BUDGET_TYPES_LOADING";
export const BATCH_EDIT_BUDGET_TYPES_SUCCESS = "BATCH_EDIT_BUDGET_TYPES_SUCCESS";
export const BATCH_EDIT_BUDGET_TYPES_ERROR = "BATCH_EDIT_BUDGET_TYPES_ERROR";
export const FETCH_PROJECT_ADDITIONAL_DATA_LOADING = "FETCH_PROJECT_ADDITIONAL_DATA_LOADING";
export const FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS = "FETCH_PROJECT_ADDITIONAL_DATA_SUCCESS";
export const FETCH_PROJECT_ADDITIONAL_DATA_ERROR = "FETCH_PROJECT_ADDITIONAL_DATA_ERROR";
export const OPEN_PROJECT_LOADING = "OPEN_PROJECT_LOADING";
export const OPEN_PROJECT_SUCCESS = "OPEN_PROJECT_SUCCESS";
export const OPEN_PROJECT_ERROR = "OPEN_PROJECT_ERROR";
export const COMPLETE_PROJECT_LOADING = "COMPLETE_PROJECT_LOADING";
export const COMPLETE_PROJECT_SUCCESS = "COMPLETE_PROJECT_SUCCESS";
export const COMPLETE_PROJECT_ERROR = "COMPLETE_PROJECT_ERROR";
export const MOVE_PROJECT_TO_TRASH_LOADING = "MOVE_PROJECT_TO_TRASH_LOADING";
export const MOVE_PROJECT_TO_TRASH_SUCCESS = "MOVE_PROJECT_TO_TRASH_SUCCESS";
export const MOVE_PROJECT_TO_TRASH_ERROR = "MOVE_PROJECT_TO_TRASH_ERROR";
export const CONVERT_TO_TEMPLATE_LOADING = "CONVERT_TO_TEMPLATE_LOADING";
export const CONVERT_TO_TEMPLATE_SUCCESS = "CONVERT_TO_TEMPLATE_SUCCESS";
export const CONVERT_TO_TEMPLATE_ERROR = "CONVERT_TO_TEMPLATE_ERROR";
export const PROJECT_TEMPLATE_APPLY_LOADING = "PROJECT_TEMPLATE_APPLY_LOADING";
export const PROJECT_TEMPLATE_APPLY_SUCCESS = "PROJECT_TEMPLATE_APPLY_SUCCESS";
export const PROJECT_TEMPLATE_APPLY_ERROR = "PROJECT_TEMPLATE_APPLY_ERROR";
export const FETCH_RESPONSIBILITIES_LOADING = "FETCH_RESPONSIBILITIES_LOADING";
export const FETCH_RESPONSIBILITIES_SUCCESS = "FETCH_RESPONSIBILITIES_SUCCESS";
export const FETCH_RESPONSIBILITIES_ERROR = "FETCH_RESPONSIBILITIES_ERROR";
export const FETCH_PROJECTS_DETAILS_LOADING = "FETCH_PROJECTS_DETAILS_LOADING";
export const FETCH_PROJECTS_DETAILS_SUCCESS = "FETCH_PROJECTS_DETAILS_SUCCESS";
export const FETCH_PROJECTS_DETAILS_ERROR = "FETCH_PROJECTS_DETAILS_ERROR";
export const ADD_USER_TO_PROJECTS_LOADING = "ADD_USER_TO_PROJECTS_LOADING";
export const ADD_USER_TO_PROJECTS_SUCCESS = "ADD_USER_TO_PROJECTS_SUCCESS";
export const ADD_USER_TO_PROJECTS_ERROR = "ADD_USER_TO_PROJECTS_ERROR";

// TASK LIST
export const ADD_TASK_LIST_LOADING = `ADD_TASK_LIST_LOADING`;
export const ADD_TASK_LIST_SUCCESS = `ADD_TASK_LIST_SUCCESS`;
export const ADD_TASK_LIST_ERROR = `ADD_TASK_LIST_ERROR`;
export const INSERT_TASK_LIST_LOADING = `INSERT_TASK_LIST_LOADING`;
export const INSERT_TASK_LIST_SUCCESS = `INSERT_TASK_LIST_SUCCESS`;
export const INSERT_TASK_LIST_ERROR = `INSERT_TASK_LIST_ERROR`;
export const EDIT_TASK_LIST_LOADING = `EDIT_TASK_LIST_LOADING`;
export const EDIT_TASK_LIST_SUCCESS = `EDIT_TASK_LIST_SUCCESS`;
export const EDIT_TASK_LIST_ERROR = `EDIT_TASK_LIST_ERROR`;
export const MOVE_TASK_LIST_TO_TRASH_LOADING = `MOVE_TASK_LIST_TO_TRASH_LOADING`;
export const MOVE_TASK_LIST_TO_TRASH_SUCCESS = `MOVE_TASK_LIST_TO_TRASH_SUCCESS`;
export const MOVE_TASK_LIST_TO_TRASH_ERROR = `MOVE_TASK_LIST_TO_TRASH_ERROR`;
export const DUPLICATE_TASK_LIST_LOADING = `DUPLICATE_TASK_LIST_LOADING`;
export const DUPLICATE_TASK_LIST_SUCCESS = `DUPLICATE_TASK_LIST_SUCCESS`;
export const DUPLICATE_TASK_LIST_ERROR = `DUPLICATE_TASK_LIST_ERROR`;
export const FETCH_TASK_LIST_LOADING = `FETCH_TASK_LIST_LOADING`;
export const FETCH_TASK_LIST_SUCCESS = `FETCH_TASK_LIST_SUCCESS`;
export const FETCH_TASK_LIST_ERROR = `FETCH_TASK_LIST_ERROR`;
export const FETCH_TASK_LISTS_LOADING = `FETCH_TASK_LISTS_LOADING`;
export const FETCH_TASK_LISTS_SUCCESS = `FETCH_TASK_LISTS_SUCCESS`;
export const FETCH_TASK_LISTS_ERROR = `FETCH_TASK_LISTS_ERROR`;
export const COMPLETE_TASK_LIST_LOADING = `COMPLETE_TASK_LIST_LOADING`;
export const COMPLETE_TASK_LIST_SUCCESS = `COMPLETE_TASK_LIST_SUCCESS`;
export const COMPLETE_TASK_LIST_ERROR = `COMPLETE_TASK_LIST_ERROR`;
export const REORDER_TASK_LIST_LOADING = `REORDER_TASK_LIST_LOADING`;
export const REORDER_TASK_LIST_SUCCESS = `REORDER_TASK_LIST_SUCCESS`;
export const REORDER_TASK_LIST_ERROR = `REORDER_TASK_LIST_ERROR`;
export const ADD_TASK_LIST_FROM_EVENT_STREAM = `ADD_TASK_LIST_FROM_EVENT_STREAM`;
export const UPDATE_TASK_LIST_FROM_EVENT_STREAM = `UPDATE_TASK_LIST_FROM_EVENT_STREAM`;
export const TASK_LIST_REORDERED_FROM_EVENT_STREAM = `TASK_LIST_REORDERED_FROM_EVENT_STREAM`;
export const TASK_LIST_MOVE_TO_TRASH_FROM_EVENT_STREAM = `TASK_LIST_MOVE_TO_TRASH_FROM_EVENT_STREAM`;
export const TASK_LIST_RESTORED_FROM_TRASH_FROM_EVENT_STREAM = `TASK_LIST_RESTORED_FROM_TRASH_FROM_EVENT_STREAM`;
export const TASK_LIST_COMPLETED_FROM_EVENT_STREAM = `TASK_LIST_COMPLETED_FROM_EVENT_STREAM`;
export const TASK_LIST_REOPENED_FROM_EVENT_STREAM = `TASK_LIST_REOPENED_FROM_EVENT_STREAM`;
export const INSERT_TASK_LIST_FROM_EVENT_STREAM = `INSERT_TASK_LIST_FROM_EVENT_STREAM`;
export const REOPEN_TASK_LIST_LOADING = `REOPEN_TASK_LIST_LOADING`;
export const REOPEN_TASK_LIST_SUCCESS = `REOPEN_TASK_LIST_SUCCESS`;
export const REOPEN_TASK_LIST_ERROR = `REOPEN_TASK_LIST_ERROR`;
export const MOVE_TASK_LIST_TO_PROJECT_LOADING = `MOVE_TASK_LIST_TO_PROJECT_LOADING`;
export const MOVE_TASK_LIST_TO_PROJECT_SUCCESS = `MOVE_TASK_LIST_TO_PROJECT_SUCCESS`;
export const MOVE_TASK_LIST_TO_PROJECT_ERROR = `MOVE_TASK_LIST_TO_PROJECT_ERROR`;
export const TASK_LIST_MOVED_TO_PROJECT_FROM_EVENT_STREAM = "TASK_LIST_MOVED_TO_PROJECT_FROM_EVENT_STREAM";

// TASKS
export const DUPLICATE_TASK_LOADING = `DUPLICATE_TASK_LOADING`;
export const DUPLICATE_TASK_SUCCESS = `DUPLICATE_TASK_SUCCESS`;
export const DUPLICATE_TASK_ERROR = `DUPLICATE_TASK_ERROR`;
export const MOVE_TASK_TO_PROJECT_LOADING = `MOVE_TASK_TO_PROJECT_LOADING`;
export const MOVE_TASK_TO_PROJECT_SUCCESS = `MOVE_TASK_TO_PROJECT_SUCCESS`;
export const MOVE_TASK_TO_PROJECT_ERROR = `MOVE_TASK_TO_PROJECT_ERROR`;
export const ADD_TASK_LOADING = `ADD_TASK_LOADING`;
export const ADD_TASK_SUCCESS = `ADD_TASK_SUCCESS`;
export const ADD_TASK_ERROR = `ADD_TASK_ERROR`;
export const ADD_TASK_FROM_CONVERSATION_LOADING = `ADD_TASK_FROM_CONVERSATION_LOADING`;
export const ADD_TASK_FROM_CONVERSATION_SUCCESS = `ADD_TASK_FROM_CONVERSATION_SUCCESS`;
export const ADD_TASK_FROM_CONVERSATION_ERROR = `ADD_TASK_FROM_CONVERSATION_ERROR`;
export const ADD_TASK_FROM_RECURRING_TASK_LOADING = `ADD_TASK_FROM_RECURRING_TASK_LOADING`;
export const ADD_TASK_FROM_RECURRING_TASK_SUCCESS = `ADD_TASK_FROM_RECURRING_TASK_SUCCESS`;
export const ADD_TASK_FROM_RECURRING_TASK_ERROR = `ADD_TASK_FROM_RECURRING_TASK_ERROR`;
export const WORKLOAD_EDIT_TASK_LOADING = `WORKLOAD_EDIT_TASK_LOADING`;
export const EDIT_TASK_LOADING = `EDIT_TASK_LOADING`;
export const EDIT_TASK_SUCCESS = `EDIT_TASK_SUCCESS`;
export const EDIT_TASK_ERROR = `EDIT_TASK_ERROR`;
export const TRASH_TASK_LOADING = `TRASH_TASK_LOADING`;
export const TRASH_TASK_SUCCESS = `TRASH_TASK_SUCCESS`;
export const TRASH_TASK_ERROR = `TRASH_TASK_ERROR`;
export const DELETE_TASK_LOADING = `DELETE_TASK_LOADING`;
export const DELETE_TASK_SUCCESS = `DELETE_TASK_SUCCESS`;
export const DELETE_TASK_ERROR = `DELETE_TASK_ERROR`;
export const DELETE_TEAM = `DELETE_TEAM`;
export const FETCH_TASKS_LOADING = `FETCH_TASKS_LOADING`;
export const FETCH_TASKS_SUCCESS = `FETCH_TASKS_SUCCESS`;
export const FETCH_TASKS_ERROR = `FETCH_TASKS_ERROR`;
export const FETCH_TASKS_ARCHIVE_LOADING = "FETCH_TASKS_ARCHIVE_LOADING";
export const FETCH_TASKS_ARCHIVE_SUCCESS = "FETCH_TASKS_ARCHIVE_SUCCESS";
export const FETCH_TASKS_ARCHIVE_ERROR = "FETCH_TASKS_ARCHIVE_ERROR";
export const FLUSH_TASKS_ARCHIVE = "FLUSH_TASKS_ARCHIVE";
export const FETCH_USER_TASKS_LOADING = `FETCH_USER_TASKS_LOADING`;
export const FETCH_USER_TASKS_SUCCESS = `FETCH_USER_TASKS_SUCCESS`;
export const FETCH_USER_TASKS_ERROR = `FETCH_USER_TASKS_ERROR`;
export const COMPLETE_TASK_LOADING = `COMPLETE_TASK_LOADING`;
export const COMPLETE_TASK_SUCCESS = `COMPLETE_TASK_SUCCESS`;
export const COMPLETE_TASK_ERROR = `COMPLETE_TASK_ERROR`;
export const OPEN_TASK_LOADING = `OPEN_TASK_LOADING`;
export const OPEN_TASK_SUCCESS = `OPEN_TASK_SUCCESS`;
export const OPEN_TASK_ERROR = `OPEN_TASK_ERROR`;
export const MOVE_TASK_TO_TRASH_LOADING = `MOVE_TASK_TO_TRASH_LOADING`;
export const MOVE_TASK_TO_TRASH_SUCCESS = `MOVE_TASK_TO_TRASH_SUCCESS`;
export const MOVE_TASK_TO_TRASH_ERROR = `MOVE_TASK_TO_TRASH_ERROR`;
export const RESTORE_TASK_FROM_TRASH_LOADING = `RESTORE_TASK_FROM_TRASH_LOADING`;
export const RESTORE_TASK_FROM_TRASH_SUCCESS = `RESTORE_TASK_FROM_TRASH_SUCCESS`;
export const RESTORE_TASK_FROM_TRASH_ERROR = `RESTORE_TASK_FROM_TRASH_ERROR`;
export const BATCH_EDIT_TASKS_LOADING = `BATCH_EDIT_TASKS_LOADING`;
export const BATCH_EDIT_TASKS_SUCCESS = `BATCH_EDIT_TASKS_SUCCESS`;
export const BATCH_EDIT_TASKS_ERROR = `BATCH_EDIT_TASKS_ERROR`;
export const BATCH_ADD_TASKS_LOADING = `BATCH_ADD_TASKS_LOADING`;
export const BATCH_ADD_TASKS_SUCCESS = `BATCH_ADD_TASKS_SUCCESS`;
export const BATCH_ADD_TASKS_ERROR = `BATCH_ADD_TASKS_ERROR`;
export const FETCH_RECURRING_TASKS_LOADING = `FETCH_RECURRING_TASKS_LOADING`;
export const FETCH_RECURRING_TASKS_SUCCESS = `FETCH_RECURRING_TASKS_SUCCESS`;
export const FETCH_RECURRING_TASKS_ERROR = `FETCH_RECURRING_TASKS_ERROR`;
export const FETCH_RECURRING_TASK_LOADING = `FETCH_RECURRING_TASK_LOADING`;
export const FETCH_RECURRING_TASK_SUCCESS = `FETCH_RECURRING_TASK_SUCCESS`;
export const FETCH_RECURRING_TASK_ERROR = `FETCH_RECURRING_TASK_ERROR`;
export const MOVE_RECURRING_TASK_TO_TRASH_LOADING = `MOVE_RECURRING_TASK_TO_TRASH_LOADING`;
export const MOVE_RECURRING_TASK_TO_TRASH_SUCCESS = `MOVE_RECURRING_TASK_TO_TRASH_SUCCESS`;
export const MOVE_RECURRING_TASK_TO_TRASH_ERROR = `MOVE_RECURRING_TASK_TO_TRASH_ERROR`;
export const EDIT_RECURRING_TASK_LOADING = `EDIT_RECURRING_TASK_LOADING`;
export const EDIT_RECURRING_TASK_SUCCESS = `EDIT_RECURRING_TASK_SUCCESS`;
export const EDIT_RECURRING_TASK_ERROR = `EDIT_RECURRING_TASK_ERROR`;
export const ADD_RECURRING_TASK_LOADING = `ADD_RECURRING_TASK_LOADING`;
export const ADD_RECURRING_TASK_SUCCESS = `ADD_RECURRING_TASK_SUCCESS`;
export const ADD_RECURRING_TASK_ERROR = `ADD_RECURRING_TASK_ERROR`;
export const REORDER_TASKS_LOADING = `REORDER_TASKS_LOADING`;
export const REORDER_TASKS_SUCCESS = `REORDER_TASKS_SUCCESS`;
export const REORDER_TASKS_ERROR = `REORDER_TASKS_ERROR`;
export const UPDATE_COMPLETED_TASKS_COUNT = `UPDATE_COMPLETED_TASKS_COUNT`;
export const FETCH_SUBTASK_LOADING = `FETCH_SUBTASK_LOADING`;
export const FETCH_SUBTASK_SUCCESS = `FETCH_SUBTASK_SUCCESS`;
export const FETCH_SUBTASK_ERROR = `FETCH_SUBTASK_ERROR`;
export const ADD_SUBTASK_LOADING = `ADD_SUBTASK_LOADING`;
export const ADD_SUBTASK_SUCCESS = `ADD_SUBTASK_SUCCESS`;
export const ADD_SUBTASK_FROM_EVENT_STREAM = `ADD_SUBTASK_FROM_EVENT_STREAM`;
export const ADD_SUBTASK_ERROR = `ADD_SUBTASK_ERROR`;
export const OPEN_SUBTASK_LOADING = `OPEN_SUBTASK_LOADING`;
export const OPEN_SUBTASK_SUCCESS = `OPEN_SUBTASK_SUCCESS`;
export const OPEN_SUBTASK_ERROR = `OPEN_SUBTASK_ERROR`;
export const DELETE_SUBTASK_LOADING = `DELETE_SUBTASK_LOADING`;
export const DELETE_SUBTASK_SUCCESS = `DELETE_SUBTASK_SUCCESS`;
export const DELETE_SUBTASK_ERROR = `DELETE_SUBTASK_ERROR`;
export const EDIT_SUBTASK_LOADING = `EDIT_SUBTASK_LOADING`;
export const EDIT_SUBTASK_SUCCESS = `EDIT_SUBTASK_SUCCESS`;
export const EDIT_SUBTASK_ERROR = `EDIT_SUBTASK_ERROR`;
export const COMPLETE_SUBTASK_LOADING = `COMPLETE_SUBTASK_LOADING`;
export const COMPLETE_SUBTASK_SUCCESS = `COMPLETE_SUBTASK_SUCCESS`;
export const COMPLETE_SUBTASK_ERROR = `COMPLETE_SUBTASK_ERROR`;
export const MOVE_SUBTASK_TO_TRASH_LOADING = `MOVE_SUBTASK_TO_TRASH_LOADING`;
export const MOVE_SUBTASK_TO_TRASH_SUCCESS = `MOVE_SUBTASK_TO_TRASH_SUCCESS`;
export const MOVE_SUBTASK_TO_TRASH_ERROR = `MOVE_SUBTASK_TO_TRASH_ERROR`;
export const RESTORE_SUBTASK_FROM_TRASH_LOADING = `RESTORE_SUBTASK_FROM_TRASH_LOADING`;
export const RESTORE_SUBTASK_FROM_TRASH_SUCCESS = `RESTORE_SUBTASK_FROM_TRASH_SUCCESS`;
export const RESTORE_SUBTASK_FROM_TRASH_ERROR = `RESTORE_SUBTASK_FROM_TRASH_ERROR`;
export const CONVERT_SUBTASK_TO_TASK_LOADING = `CONVERT_SUBTASK_TO_TASK_LOADING`;
export const CONVERT_SUBTASK_TO_TASK_SUCCESS = `CONVERT_SUBTASK_TO_TASK_SUCCESS`;
export const CONVERT_SUBTASK_TO_TASK_ERROR = `CONVERT_SUBTASK_TO_TASK_ERROR`;
export const FETCH_SUBTASKS_LOADING = `FETCH_SUBTASKS_LOADING`;
export const FETCH_SUBTASKS_SUCCESS = `FETCH_SUBTASKS_SUCCESS`;
export const FETCH_SUBTASKS_ERROR = `FETCH_SUBTASKS_ERROR`;
export const REORDER_SUBTASKS_LOADING = `REORDER_SUBTASKS_LOADING`;
export const REORDER_SUBTASKS_SUCCESS = `REORDER_SUBTASKS_SUCCESS`;
export const REORDER_SUBTASKS_ERROR = `REORDER_SUBTASKS_ERROR`;
export const FETCH_SUBTASKS_TIMELINE_LOADING = `FETCH_SUBTASKS_TIMELINE_LOADING`;
export const FETCH_SUBTASKS_TIMELINE_SUCCESS = `FETCH_SUBTASKS_TIMELINE_SUCCESS`;
export const FETCH_SUBTASKS_TIMELINE_ERROR = `FETCH_SUBTASKS_TIMELINE_ERROR`;
export const BATCH_ADD_SUBTASKS_LOADING = "BATCH_ADD_SUBTASKS_LOADING";
export const BATCH_ADD_SUBTASKS_SUCCESS = "BATCH_ADD_SUBTASKS_SUCCESS";
export const BATCH_ADD_SUBTASKS_ERROR = "BATCH_ADD_SUBTASKS_ERROR";
export const COMPLETE_TASK_TOGGLER = `COMPLETE_TASK_TOGGLER`;
export const RESCHEDULE_TASK_LOADING = `RESCHEDULE_TASK_LOADING`;
export const RESCHEDULE_TASK_SUCCESS = `RESCHEDULE_TASK_SUCCESS`;
export const RESCHEDULE_TASK_ERROR = `RESCHEDULE_TASK_ERROR`;
export const FETCH_TASK_RESCHEDULE_SIMULATION_LOADING = `FETCH_TASK_RESCHEDULE_SIMULATION_LOADING`;
export const FETCH_TASK_RESCHEDULE_SIMULATION_SUCCESS = `FETCH_TASK_RESCHEDULE_SIMULATION_SUCCESS`;
export const FETCH_TASK_RESCHEDULE_SIMULATION_ERROR = `FETCH_TASK_RESCHEDULE_SIMULATION_ERROR`;
export const CLEAR_RESCHEDULE_SIMULATION = `CLEAR_RESCHEDULE_SIMULATION`;
export const UPDATE_TASK_FROM_EVENT_STREAM = `UPDATE_TASK_FROM_EVENT_STREAM`;
export const CHANGE_TASK = `CHANGE_TASK`;
export const ADD_TASK_FROM_EVENT_STREAM = `ADD_TASK_FROM_EVENT_STREAM`;
export const COMPLETE_TASK_FROM_EVENT_STREAM = `COMPLETE_TASK_FROM_EVENT_STREAM`;
export const TASK_LIST_CHANGED_FROM_EVENT_STREAM = `TASK_LIST_CHANGED_FROM_EVENT_STREAM`;
export const TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM = `TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM`;
export const TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM = `TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM`;
export const TASK_REORDERED_FROM_EVENT_STREAM = `TASK_REORDERED_FROM_EVENT_STREAM`;
export const REOPENED_TASK_FROM_EVENT_STREAM = `REOPENED_TASK_FROM_EVENT_STREAM`;
export const FLUSH_ALL_TASKS_FROM_STORE = `FLUSH_ALL_TASKS_FROM_STORE`;
export const TASK_DEPENDENCIES_UPDATED_FROM_EVENT_STREAM = `TASK_DEPENDENCIES_UPDATED_FROM_EVENT_STREAM`;
export const ADD_RECURRING_TASK_FROM_EVENT_STREAM = `ADD_RECURRING_TASK_FROM_EVENT_STREAM`;
export const RECURRING_TASK_MOVED_TO_TRASH_FROM_EVENT_STREAM = `RECURRING_TASK_MOVE_TO_TRASH_FROM_EVENT_STREAM`;
export const UPDATE_RECURRING_TASK_FROM_EVENT_STREAM = `UPDATE_RECURRING_TASK_FROM_EVENT_STREAM`;
export const RECURRING_TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM = `RECURRING_TASK_RESTORED_FROM_TRASH_FROM_EVENT_STREAM`;
export const TASK_MOVED_TO_PROJECT_FROM_EVENT_STREAM = "TASK_MOVED_TO_PROJECT_FROM_EVENT_STREAM";

// TASK DEPENDENCIES
export const FETCH_TASK_DEPENDENCIES_LOADING = `FETCH_TASK_DEPENDENCIES_LOADING`;
export const FETCH_TASK_DEPENDENCIES_SUCCESS = `FETCH_TASK_DEPENDENCIES_SUCCESS`;
export const FETCH_TASK_DEPENDENCIES_ERROR = `FETCH_TASK_DEPENDENCIES_ERROR`;
export const FETCH_PROJECT_TASK_DEPENDENCIES_LOADING = `FETCH_PROJECT_TASK_DEPENDENCIES_LOADING`;
export const FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS = `FETCH_PROJECT_TASK_DEPENDENCIES_SUCCESS`;
export const FETCH_PROJECT_TASK_DEPENDENCIES_ERROR = `FETCH_PROJECT_TASK_DEPENDENCIES_ERROR`;
export const FETCH_TASK_DEPENDENCIES_SUGGESTIONS_LOADING = `FETCH_TASK_DEPENDENCIES_SUGGESTIONS_LOADING`;
export const FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS = `FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS`;
export const FETCH_TASK_DEPENDENCIES_SUGGESTIONS_ERROR = `FETCH_TASK_DEPENDENCIES_SUGGESTIONS_ERROR`;
export const ADD_TASK_DEPENDENCIES_LOADING = `ADD_TASK_DEPENDENCIES_LOADING`;
export const ADD_TASK_DEPENDENCIES_SUCCESS = `ADD_TASK_DEPENDENCIES_SUCCESS`;
export const ADD_TASK_DEPENDENCIES_ERROR = `ADD_TASK_DEPENDENCIES_ERROR`;
export const DELETE_TASK_DEPENDENCIES_LOADING = `DELETE_TASK_DEPENDENCIES_LOADING`;
export const DELETE_TASK_DEPENDENCIES_SUCCESS = `DELETE_TASK_DEPENDENCIES_SUCCESS`;
export const DELETE_TASK_DEPENDENCIES_ERROR = `DELETE_TASK_DEPENDENCIES_ERROR`;

// USERS
export const FETCH_USERS_LOADING = `FETCH_USERS_LOADING`;
export const FETCH_USERS_SUCCESS = `FETCH_USERS_SUCCESS`;
export const FETCH_USERS_ERROR = `FETCH_USERS_ERROR`;
export const FETCH_ALL_USERS_LOADING = `FETCH_ALL_USERS_LOADING`;
export const FETCH_ALL_USERS_SUCCESS = `FETCH_ALL_USERS_SUCCESS`;
export const FETCH_ALL_USERS_ERROR = `FETCH_ALL_USERS_ERROR`;
export const ADD_USER_LOADING = `ADD_USER_LOADING`;
export const ADD_USER_SUCCESS = `ADD_USER_SUCCESS`;
export const ADD_USER_ERROR = `ADD_USER_ERROR`;
export const INVITE_USER_LOADING = `INVITE_USER_LOADING`;
export const INVITE_USER_SUCCESS = `INVITE_USER_SUCCESS`;
export const INVITE_USER_ERROR = `INVITE_USER_ERROR`;
export const CREATE_VIRTUAL_USER_LOADING = `CREATE_VIRTUAL_USER_LOADING`;
export const CREATE_VIRTUAL_USER_SUCCESS = `CREATE_VIRTUAL_USER_SUCCESS`;
export const CREATE_VIRTUAL_USER_ERROR = `CREATE_VIRTUAL_USER_ERROR`;
export const ACTIVATE_VIRTUAL_USER_LOADING = `ACTIVATE_VIRTUAL_USER_LOADING`;
export const ACTIVATE_VIRTUAL_USER_SUCCESS = `ACTIVATE_VIRTUAL_USER_SUCCESS`;
export const ACTIVATE_VIRTUAL_USER_ERROR = `ACTIVATE_VIRTUAL_USER_ERROR`;
export const EDIT_USER_LOADING = `EDIT_USER_LOADING`;
export const EDIT_USER_SUCCESS = `EDIT_USER_SUCCESS`;
export const EDIT_USER_ERROR = `EDIT_USER_ERROR`;
export const EDIT_VIRTUAL_USER_LOADING = `EDIT_VIRTUAL_USER_LOADING`;
export const EDIT_VIRTUAL_USER_SUCCESS = `EDIT_VIRTUAL_USER_SUCCESS`;
export const EDIT_VIRTUAL_USER_ERROR = `EDIT_VIRTUAL_USER_ERROR`;
export const UPDATE_POLICY_USER_LOADING = `UPDATE_POLICY_USER_LOADING`;
export const UPDATE_POLICY_USER_SUCCESS = `UPDATE_POLICY_USER_SUCCESS`;
export const UPDATE_POLICY_USER_ERROR = `UPDATE_POLICY_USER_ERROR`;
export const ADD_USER_FROM_EVENT_STREAM_SUCCESS = `ADD_USER_FROM_EVENT_STREAM_SUCCESS`;
export const EDIT_USER_FROM_EVENT_STREAM_SUCCESS = `EDIT_USER_FROM_EVENT_STREAM_SUCCESS`;
export const USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS = `USER_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS`;
export const USER_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS = `USER_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS`;
export const MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS = `MOVE_USER_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS`;
export const RESTORE_USER_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS = `RESTORE_USER_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS`;
export const EDIT_LOGGED_USER_LOADING = `EDIT_LOGGED_USER_LOADING`;
export const EDIT_LOGGED_USER_SUCCESS = `EDIT_LOGGED_USER_SUCCESS`;
export const EDIT_LOGGED_USER_ERROR = `EDIT_LOGGED_USER_ERROR`;
export const INVITE_USER_TO_PROJECT_LOADING = "INVITE_USER_TO_PROJECT_LOADING";
export const INVITE_USER_TO_PROJECT_SUCCESS = "INVITE_USER_TO_PROJECT_SUCCESS";
export const INVITE_USER_TO_PROJECT_ERROR = "INVITE_USER_TO_PROJECT_ERROR";
export const FETCH_USERS_WORKWEEK_CAPACITIES_LOADING = `FETCH_USERS_WORKWEEK_CAPACITIES_LOADING`;
export const FETCH_USERS_WORKWEEK_CAPACITIES_SUCCESS = `FETCH_USERS_WORKWEEK_CAPACITIES_SUCCESS`;
export const FETCH_USERS_WORKWEEK_CAPACITIES_ERROR = `FETCH_USERS_WORKWEEK_CAPACITIES_ERROR`;
export const EDIT_USERS_WORKWEEK_CAPACITIES_LOADING = `EDIT_USERS_WORKWEEK_CAPACITIES_LOADING`;
export const EDIT_USERS_WORKWEEK_CAPACITIES_SUCCESS = `EDIT_USERS_WORKWEEK_CAPACITIES_SUCCESS`;
export const EDIT_USERS_WORKWEEK_CAPACITIES_ERROR = `EDIT_USERS_WORKWEEK_CAPACITIES_ERROR`;
export const CHANGE_USER_PERMISSIONS_LOADING = `CHANGE_USER_PERMISSIONS_LOADING`;
export const CHANGE_USER_PERMISSIONS_SUCCESS = `CHANGE_USER_PERMISSIONS_SUCCESS`;
export const CHANGE_USER_PERMISSIONS_ERROR = `CHANGE_USER_PERMISSIONS_ERROR`;
export const ARCHIVE_REPLACE_USER_LOADING = `ARCHIVE_REPLACE_USER_LOADING`;
export const ARCHIVE_REPLACE_USER_SUCCESS = `ARCHIVE_REPLACE_USER_SUCCESS`;
export const ARCHIVE_REPLACE_USER_ERROR = `ARCHIVE_REPLACE_USER_ERROR`;
export const REMOVE_REPLACE_USER_LOADING = `REMOVE_REPLACE_USER_LOADING`;
export const REMOVE_REPLACE_USER_SUCCESS = `REMOVE_REPLACE_USER_SUCCESS`;
export const REMOVE_REPLACE_USER_ERROR = `REMOVE_REPLACE_USER_ERROR`;
export const SUBMIT_BASIC_DETAILS_ONBOARDING_SUCCESS = `SUBMIT_BASIC_DETAILS_ONBOARDING_SUCCESS`;
export const SUBMIT_BASIC_DETAILS_ONBOARDING_LOADING = `SUBMIT_BASIC_DETAILS_ONBOARDING_LOADING`;
export const SUBMIT_BASIC_DETAILS_ONBOARDING_ERROR = `SUBMIT_BASIC_DETAILS_ONBOARDING_ERROR`;
export const SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_SUCCESS = `SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_SUCCESS`;
export const SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_LOADING = `SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_LOADING`;
export const SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_ERROR = `SUBMIT_ORGANIZATION_DETAILS_ONBOARDING_ERROR`;
export const EDIT_CLIENT_PLUS_SUCCESS = `EDIT_CLIENT_PLUS_SUCCESS`;
export const EDIT_CLIENT_PLUS_LOADING = `EDIT_CLIENT_PLUS_LOADING`;
export const EDIT_CLIENT_PLUS_ERROR = `EDIT_CLIENT_PLUS_ERROR`;

// COMPANIES
export const LOAD_COMPANIES = `LOAD_COMPANIES`;
export const LOAD_COMPANY = `LOAD_COMPANY`;
export const ADD_COMPANY = `ADD_COMPANY`;
export const EDIT_COMPANY = `EDIT_COMPANY`;
export const TRASH_COMPANY = `TRASH_COMPANY`;
export const EDIT_COMPANY_LOADING = `EDIT_COMPANY_LOADING`;
export const EDIT_COMPANY_SUCCESS = `EDIT_COMPANY_SUCCESS`;
export const EDIT_COMPANY_ERROR = `EDIT_COMPANY_ERROR`;
export const ARCHIVE_COMPANY_LOADING = `ARCHIVE_COMPANY_LOADING`;
export const ARCHIVE_COMPANY_SUCCESS = `ARCHIVE_COMPANY_SUCCESS`;
export const ARCHIVE_COMPANY_ERROR = `ARCHIVE_COMPANY_ERROR`;
export const MOVE_COMPANY_TO_TRASH_LOADING = `MOVE_COMPANY_TO_TRASH_LOADING`;
export const MOVE_COMPANY_TO_TRASH_SUCCESS = `MOVE_COMPANY_TO_TRASH_SUCCESS`;
export const MOVE_COMPANY_TO_TRASH_ERROR = `MOVE_COMPANY_TO_TRASH_ERROR`;
export const ADD_COMPANY_FROM_EVENT_STREAM_SUCCESS = `ADD_COMPANY_FROM_EVENT_STREAM_SUCCESS`;
export const EDIT_COMPANY_FROM_EVENT_STREAM_SUCCESS = `EDIT_COMPANY_FROM_EVENT_STREAM_SUCCESS`;
export const COMPANY_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS = `COMPANY_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS`;
export const COMPANY_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS = `COMPANY_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS`;
export const MOVE_COMPANY_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS = `MOVE_COMPANY_TO_ARCHIVE_FROM_EVENT_STREAM_SUCCESS`;
export const RESTORE_COMPANY_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS = `RESTORE_COMPANY_FROM_ARCHIVE_FROM_EVENT_STREAM_SUCCESS`;

// DISCUSSIONS
export const ADD_DISCUSSION_SUCCESS = `ADD_DISCUSSION_SUCCESS`;
export const ADD_DISCUSSION_LOADING = `ADD_DISCUSSION_LOADING`;
export const ADD_DISCUSSION_ERROR = `ADD_DISCUSSION_ERROR`;
export const FETCH_DISCUSSION_LOADING = `FETCH_DISCUSSION_LOADING`;
export const FETCH_DISCUSSION_ERROR = `FETCH_DISCUSSION_ERROR`;
export const FETCH_DISCUSSION_SUCCESS = `FETCH_DISCUSSION_SUCCESS`;
export const PREFETCH_DISCUSSION_LOADING = `PREFETCH_DISCUSSION_LOADING`;
export const PREFETCH_DISCUSSION_ERROR = `PREFETCH_DISCUSSION_ERROR`;
export const PREFETCH_DISCUSSION_SUCCESS = `PREFETCH_DISCUSSION_SUCCESS`;
export const FETCH_DISCUSSIONS_LOADING = `FETCH_DISCUSSIONS_LOADING`;
export const FETCH_DISCUSSIONS_ERROR = `FETCH_DISCUSSIONS_ERROR`;
export const FETCH_DISCUSSIONS_SUCCESS = `FETCH_DISCUSSIONS_SUCCESS`;
export const EDIT_DISCUSSION_SUCCESS = `EDIT_DISCUSSION_SUCCESS`;
export const EDIT_DISCUSSION_LOADING = `EDIT_DISCUSSION_LOADING`;
export const EDIT_DISCUSSION_ERROR = `EDIT_DISCUSSION_ERROR`;
export const MOVE_DISCUSSION_TO_TRASH_SUCCESS = `MOVE_DISCUSSION_TO_TRASH_SUCCESS`;
export const MOVE_DISCUSSION_TO_TRASH_LOADING = `MOVE_DISCUSSION_TO_TRASH_LOADING`;
export const MOVE_DISCUSSION_TO_TRASH_ERROR = `MOVE_DISCUSSION_TO_TRASH_ERROR`;
export const RESTORE_DISCUSSION_FROM_TRASH_SUCCESS = `RESTORE_DISCUSSION_FROM_TRASH_SUCCESS`;
export const RESTORE_DISCUSSION_FROM_TRASH_LOADING = `RESTORE_DISCUSSION_FROM_TRASH_LOADING`;
export const RESTORE_DISCUSSION_FROM_TRASH_ERROR = `RESTORE_DISCUSSION_FROM_TRASH_ERROR`;
export const ADD_DISCUSSION_FROM_EVENT_STREAM = `ADD_DISCUSSION_FROM_EVENT_STREAM`;
export const UPDATE_DISCUSSION_FROM_EVENT_STREAM = `UPDATE_DISCUSSION_FROM_EVENT_STREAM`;
export const MOVE_DISCUSSION_TO_TRASH_FROM_EVENT_STREAM = `MOVE_DISCUSSION_TO_TRASH_FROM_EVENT_STREAM`;
export const RESTORE_DISCUSSION_FROM_TRASH_FROM_EVENT_STREAM = `RESTORE_DISCUSSION_FROM_TRASH_FROM_EVENT_STREAM`;
export const EMPTY_DISCUSSIONS = `EMPTY_DISCUSSIONS`;
export const CONVERT_DISCUSSION_TO_TASK_LOADING = `CONVERT_DISCUSSION_TO_TASK_LOADING`;
export const CONVERT_DISCUSSION_TO_TASK_ERROR = `CONVERT_DISCUSSION_TO_TASK_ERROR`;
export const CONVERT_DISCUSSION_TO_TASK_SUCCESS = `CONVERT_DISCUSSION_TO_TASK_SUCCESS`;
export const MOVE_DISCUSSION_TO_PROJECT_LOADING = `MOVE_DISCUSSION_TO_PROJECT_LOADING`;
export const MOVE_DISCUSSION_TO_PROJECT_SUCCESS = `MOVE_DISCUSSION_TO_PROJECT_SUCCESS`;
export const MOVE_DISCUSSION_TO_PROJECT_ERROR = `MOVE_DISCUSSION_TO_PROJECT_ERROR`;
export const FETCH_DISCUSSION_READ_STATUSES_LOADING = `FETCH_DISCUSSION_READ_STATUSES_LOADING`;
export const FETCH_DISCUSSION_READ_STATUSES_SUCCESS = `FETCH_DISCUSSION_READ_STATUSES_SUCCESS`;
export const FETCH_DISCUSSION_READ_STATUSES_ERROR = `FETCH_DISCUSSION_READ_STATUSES_ERROR`;
export const DISCUSSION_MOVED_TO_PROJECT_FROM_EVENT_STREAM = "DISCUSSION_MOVED_TO_PROJECT_FROM_EVENT_STREAM";

// NOTES
export const DUPLICATE_NOTE_LOADING = `DUPLICATE_NOTE_LOADING`;
export const DUPLICATE_NOTE_SUCCESS = `DUPLICATE_NOTE_SUCCESS`;
export const DUPLICATE_NOTE_ERROR = `DUPLICATE_NOTE_ERROR`;
export const ADD_NOTE_SUCCESS = `ADD_NOTE_SUCCESS`;
export const ADD_NOTE_LOADING = `ADD_NOTE_LOADING`;
export const ADD_NOTE_ERROR = `ADD_NOTE_ERROR`;
export const FETCH_NOTE_LOADING = `FETCH_NOTE_LOADING`;
export const FETCH_NOTE_ERROR = `FETCH_NOTE_ERROR`;
export const FETCH_NOTE_SUCCESS = `FETCH_NOTE_SUCCESS`;
export const PREFETCH_NOTE_LOADING = `PREFETCH_NOTE_LOADING`;
export const PREFETCH_NOTE_ERROR = `PREFETCH_NOTE_ERROR`;
export const PREFETCH_NOTE_SUCCESS = `PREFETCH_NOTE_SUCCESS`;
export const EDIT_NOTE_LOADING = `EDIT_NOTE_LOADING`;
export const EDIT_NOTE_SUCCESS = `EDIT_NOTE_SUCCESS`;
export const EDIT_NOTE_ERROR = `EDIT_NOTE_ERROR`;
export const MOVE_NOTE_TO_TRASH_LOADING = `MOVE_NOTE_TO_TRASH_LOADING`;
export const MOVE_NOTE_TO_TRASH_SUCCESS = `MOVE_NOTE_TO_TRASH_SUCCESS`;
export const MOVE_NOTE_TO_TRASH_ERROR = `MOVE_NOTE_TO_TRASH_ERROR`;
export const RESTORE_NOTE_FROM_TRASH_LOADING = `RESTORE_NOTE_FROM_TRASH_LOADING`;
export const RESTORE_NOTE_FROM_TRASH_SUCCESS = `RESTORE_NOTE_FROM_TRASH_SUCCESS`;
export const RESTORE_NOTE_FROM_TRASH_ERROR = `RESTORE_NOTE_FROM_TRASH_ERROR`;
export const ADD_NOTE_FROM_EVENT_STREAM = `ADD_NOTE_FROM_EVENT_STREAM`;
export const UPDATE_NOTE_FROM_EVENT_STREAM = `UPDATE_NOTE_FROM_EVENT_STREAM`;
export const MOVE_NOTE_TO_TRASH_FROM_EVENT_STREAM = `MOVE_NOTE_TO_TRASH_FROM_EVENT_STREAM`;
export const RESTORE_NOTE_FROM_TRASH_FROM_EVENT_STREAM = `RESTORE_NOTE_FROM_TRASH_FROM_EVENT_STREAM`;
export const FETCH_NOTES_LOADING = "FETCH_NOTES_LOADING";
export const FETCH_NOTES_SUCCESS = "FETCH_NOTES_SUCCESS";
export const FETCH_NOTES_ERROR = "FETCH_NOTES_ERROR";
export const FETCH_NOTEBOOK_NOTES_LOADING = `FETCH_NOTEBOOK_NOTES_LOADING`;
export const FETCH_NOTEBOOK_NOTES_SUCCESS = `FETCH_NOTEBOOK_NOTES_SUCCESS`;
export const FETCH_NOTEBOOK_NOTES_ERROR = `FETCH_NOTEBOOK_NOTES_ERROR`;

export const MOVE_NOTE_TO_PROJECT_LOADING = `MOVE_NOTE_TO_PROJECT_LOADING`;
export const MOVE_NOTE_TO_PROJECT_SUCCESS = `MOVE_NOTE_TO_PROJECT_SUCCESS`;
export const MOVE_NOTE_TO_PROJECT_ERROR = `MOVE_NOTE_TO_PROJECT_ERROR`;
export const CLEAR_NOTES = "CLEAR_NOTES";

export const REVERT_NOTE_TO_ORIGINAL_LOADING = "REVERT_NOTE_TO_ORIGINAL_LOADING";
export const REVERT_NOTE_TO_ORIGINAL_ERROR = "REVERT_NOTE_TO_ORIGINAL_ERROR";
export const REVERT_NOTE_TO_ORIGINAL_SUCCESS = "REVERT_NOTE_TO_ORIGINAL_SUCCESS";
export const REVERT_NOTE_TO_MODIFICATION_LOADING = "REVERT_NOTE_TO_MODIFICATION_LOADING";
export const REVERT_NOTE_TO_MODIFICATION_ERROR = "REVERT_NOTE_TO_MODIFICATION_ERROR";
export const REVERT_NOTE_TO_MODIFICATION_SUCCESS = "REVERT_NOTE_TO_MODIFICATION_SUCCESS";
export const NOTE_MOVED_TO_PROJECT_FROM_EVENT_STREAM = "NOTE_MOVED_TO_PROJECT_FROM_EVENT_STREAM";

// COMMENTS
export const FETCH_COMMENTS_SUCCESS = `FETCH_COMMENTS_SUCCESS`;
export const FETCH_COMMENTS_LOADING = `FETCH_COMMENTS_LOADING`;
export const FETCH_COMMENTS_ERROR = `FETCH_COMMENTS_ERROR`;
export const ADD_COMMENT_SUCCESS = `ADD_COMMENT_SUCCESS`;
export const ADD_COMMENT_LOADING = `ADD_COMMENT_LOADING`;
export const ADD_COMMENT_ERROR = `ADD_COMMENT_ERROR`;
export const EDIT_COMMENT_SUCCESS = `EDIT_COMMENT_SUCCESS`;
export const EDIT_COMMENT_LOADING = `EDIT_COMMENT_LOADING`;
export const EDIT_COMMENT_ERROR = `EDIT_COMMENT_ERROR`;
export const MOVE_COMMENT_TO_TRASH_LOADING = `MOVE_COMMENT_TO_TRASH_LOADING`;
export const MOVE_COMMENT_TO_TRASH_SUCCESS = `MOVE_COMMENT_TO_TRASH_SUCCESS`;
export const MOVE_COMMENT_TO_TRASH_ERROR = `MOVE_COMMENT_TO_TRASH_ERROR`;
export const DELETE_COMMENT_SUCCESS = `DELETE_COMMENT_SUCCESS`;
export const DELETE_COMMENT_LOADING = `DELETE_COMMENT_LOADING`;
export const DELETE_COMMENT_ERROR = `DELETE_COMMENT_ERROR`;
export const ADD_COMMENT_FROM_EVENT_STREAM_LOADING = `ADD_COMMENT_FROM_EVENT_STREAM_LOADING`;
export const ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS = `ADD_COMMENT_FROM_EVENT_STREAM_SUCCESS`;
export const ADD_COMMENT_FROM_EVENT_STREAM_ERROR = `ADD_COMMENT_FROM_EVENT_STREAM_ERROR`;
export const UPDATE_COMMENT_FROM_EVENT_STREAM_LOADING = `UPDATE_COMMENT_FROM_EVENT_STREAM_LOADING`;
export const UPDATE_COMMENT_FROM_EVENT_STREAM_SUCCESS = `UPDATE_COMMENT_FROM_EVENT_STREAM_SUCCESS`;
export const UPDATE_COMMENT_FROM_EVENT_STREAM_ERROR = `UPDATE_COMMENT_FROM_EVENT_STREAM_ERROR`;

export const APPEND_TO_PARENT_LOADING = "APPEND_TO_PARENT_LOADING";
export const APPEND_TO_PARENT_SUCCESS = "APPEND_TO_PARENT_SUCCESS";
export const APPEND_TO_PARENT_ERROR = "APPEND_TO_PARENT_ERROR";
export const CREATE_TASK_FROM_COMMENT_LOADING = `CREATE_TASK_FROM_COMMENT_LOADING`;
export const CREATE_TASK_FROM_COMMENT_SUCCESS = `CREATE_TASK_FROM_COMMENT_SUCCESS`;
export const CREATE_TASK_FROM_COMMENT_ERROR = `CREATE_TASK_FROM_COMMENT_ERROR`;

// UPLOAD_FILES
export const UPLOAD_FILE_BEGINS = `UPLOAD_FILE_BEGINS`;
export const UPLOAD_FILE_LOADING = `UPLOAD_FILE_LOADING`;
export const UPLOAD_FILE_SUCCESS = `UPLOAD_FILE_SUCCESS`;
export const UPLOAD_FILE_ERROR = `UPLOAD_FILE_ERROR`;
export const REMOVE_UPLOADED_FILE = `REMOVE_UPLOADED_FILE`;
export const REMOVE_ATTACHED_FILE = `REMOVE_ATTACHED_FILE`;
export const REMOVE_UNFINISHED_FILE_UPLOADS = `REMOVE_UNFINISHED_FILE_UPLOADS`;
export const RESET_UPLOADED_FILES = `RESET_UPLOADED_FILES`;

// UPLOAD DROPBOX FILES
export const UPLOAD_DROPBOX_FILES_LOADING = `UPLOAD_DROPBOX_FILES_LOADING`;
export const UPLOAD_DROPBOX_FILES_SUCCESS = `UPLOAD_DROPBOX_FILES_SUCCESS`;
export const UPLOAD_DROPBOX_FILES_ERROR = `UPLOAD_DROPBOX_FILES_ERROR`;

// UPLOAD GOOGLE DRIVE FILES
export const UPLOAD_GDRIVE_FILES_LOADING = `UPLOAD_GDRIVE_FILES_LOADING`;
export const UPLOAD_GDRIVE_FILES_SUCCESS = `UPLOAD_GDRIVE_FILES_SUCCESS`;
export const UPLOAD_GDRIVE_FILES_ERROR = `UPLOAD_GDRIVE_FILES_ERROR`;

export const ADD_UPLOADED_FILE = `ADD_UPLOADED_FILE`;
export const ADD_GDRIVE_FILES = `ADD_GDRIVE_FILES`;
export const ADD_DROPBOX_FILES = `ADD_DROPBOX_FILES`;

// LABELS
export const FETCH_LABELS_LOADING = `FETCH_LABELS_LOADING`;
export const FETCH_LABELS_SUCCESS = `FETCH_LABELS_SUCCESS`;
export const FETCH_LABELS_ERROR = `FETCH_LABELS_ERROR`;
export const ADD_LABEL_LOADING = `ADD_LABEL_LOADING`;
export const ADD_LABEL_SUCCESS = `ADD_LABEL_SUCCESS`;
export const ADD_LABEL_ERROR = `ADD_LABEL_ERROR`;
export const ADD_LABEL_TO_PROJECT = `ADD_LABEL_TO_PROJECT`;
export const DELETE_LABEL_LOADING = `DELETE_LABEL_LOADING`;
export const DELETE_LABEL_SUCCESS = `DELETE_LABEL_SUCCESS`;
export const DELETE_LABEL_ERROR = `DELETE_LABEL_ERROR`;
export const EDIT_LABEL_LOADING = `EDIT_LABEL_LOADING`;
export const EDIT_LABEL_SUCCESS = `EDIT_LABEL_SUCCESS`;
export const EDIT_LABEL_ERROR = `EDIT_LABEL_ERROR`;
export const ADD_LABEL_FROM_EVENT_STREAM = "ADD_LABEL_FROM_EVENT_STREAM";
export const UPDATE_LABEL_FROM_EVENT_STREAM = "UPDATE_LABEL_FROM_EVENT_STREAM";
export const DELETE_LABEL_FROM_EVENT_STREAM = "DELETE_LABEL_FROM_EVENT_STREAM";

// CONFIG OPTIONS
export const FETCH_CONFIG_OPTIONS_LOADING = `FETCH_CONFIG_OPTIONS_LOADING`;
export const FETCH_CONFIG_OPTIONS_SUCCESS = `FETCH_CONFIG_OPTIONS_SUCCESS`;
export const FETCH_CONFIG_OPTIONS_ERROR = `FETCH_CONFIG_OPTIONS_ERROR`;
export const EDIT_CONFIG_OPTIONS_LOADING = `EDIT_CONFIG_OPTIONS_LOADING`;
export const EDIT_CONFIG_OPTIONS_SUCCESS = `EDIT_CONFIG_OPTIONS_SUCCESS`;
export const EDIT_CONFIG_OPTIONS_ERROR = `EDIT_CONFIG_OPTIONS_ERROR`;
export const COMPLETE_ONBOARDING_LOADING = `COMPLETE_ONBOARDING_LOADING`;
export const COMPLETE_ONBOARDING_SUCCESS = `COMPLETE_ONBOARDING_SUCCESS`;
export const COMPLETE_ONBOARDING_ERROR = `COMPLETE_ONBOARDING_ERROR`;

// PERSONALIZED CONFIG OPTIONS
export const EDIT_PERSONALIZED_CONFIG_OPTIONS_LOADING = `EDIT_PERSONALIZED_CONFIG_OPTIONS_LOADING`;
export const EDIT_PERSONALIZED_CONFIG_OPTIONS_SUCCESS = `EDIT_PERSONALIZED_CONFIG_OPTIONS_SUCCESS`;
export const EDIT_PERSONALIZED_CONFIG_OPTIONS_ERROR = `EDIT_PERSONALIZED_CONFIG_OPTIONS_ERROR`;
export const FETCH_PERSONALIZED_CONFIG_OPTIONS_LOADING = `FETCH_PERSONALIZED_CONFIG_OPTIONS_LOADING`;
export const FETCH_PERSONALIZED_CONFIG_OPTIONS_SUCCESS = `FETCH_PERSONALIZED_CONFIG_OPTIONS_SUCCESS`;
export const FETCH_PERSONALIZED_CONFIG_OPTIONS_ERROR = `FETCH_PERSONALIZED_CONFIG_OPTIONS_ERROR`;
export const EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_LOADING =
  "EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_LOADING";
export const EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_SUCCESS =
  "EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_SUCCESS";
export const EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_ERROR =
  "EDIT_TIME_DASHBOARD_INTERVAL_PERSONALIZED_CONFIG_OPTIONS_ERROR";

//NEW FEATURES
export const FETCH_NEW_FEATURES_LOADING = "FETCH_NEW_FEATURES_LOADING";
export const FETCH_NEW_FEATURES_SUCCESS = "FETCH_NEW_FEATURES_SUCCESS";
export const FETCH_NEW_FEATURES_ERROR = "FETCH_NEW_FEATURES_ERROR";

export const TIMELINE_TASK_UPDATED = `TIMELINE_TASK_UPDATED`;
export const TIMELINE_TASK_DELETED = `TIMELINE_TASK_DELETED`;

export const ADD_PROJECT = `ADD_PROJECT`;

export const ADD_USER = `ADD_USER`;
export const ADD_TEAM = `ADD_TEAM`;
export const ADD_COMMENT = `ADD_COMMENT`;

export const EDIT_TASK = `EDIT_TASK`;
export const EDIT_USER = `EDIT_USER`;
export const EDIT_TEAM = `EDIT_TEAM`;
export const CREATE_TEAM_FROM_EVENT_STREAM = `CREATE_TEAM_FROM_EVENT_STREAM`;
export const UPDATE_TEAM_FROM_EVENT_STREAM = `UPDATE_TEAM_FROM_EVENT_STREAM`;
export const DELETE_TEAM_FROM_EVENT_STREAM = `DELETE_TEAM_FROM_EVENT_STREAM`;
export const EDIT_CONFIG_OPTION = `EDIT_CONFIG_OPTION`;
export const SET_CONFIG_OPTION = `SET_CONFIG_OPTION`;
export const SET_PERSONALIZED_CONFIG_OPTION = `SET_PERSONALIZED_CONFIG_OPTION`;
export const EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING =
  "EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING";
export const EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS =
  "EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS";
export const EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR =
  "EDIT_WORKLOAD_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR";
export const EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING =
  "EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_LOADING";
export const EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS =
  "EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_SUCCESS";
export const EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR =
  "EDIT_TIMESHEET_PEOPLE_PICKER_PERSONALIZED_CONFIG_OPTION_ERROR";
export const EDIT_COMMENT = `EDIT_COMMENT`;

export const TRASH_PROJECT = `TRASH_PROJECT`;
export const TRASH_TASK = `TRASH_TASK`;

// TRASH
export const MOVE_TO_TRASH_PENDING = `MOVE_TO_TRASH_PENDING`;
export const MOVE_TO_TRASH_SUCCESS = `MOVE_TO_TRASH_SUCCESS`;
export const MOVE_TO_TRASH_ERROR = `MOVE_TO_TRASH_ERROR`;
export const RESTORED_FROM_TRASH_PENDING = `RESTORED_FROM_TRASH_PENDING`;
export const RESTORED_FROM_TRASH_SUCCESS = `RESTORED_FROM_TRASH_SUCCESS`;
export const RESTORED_FROM_TRASH_ERROR = `RESTORED_FROM_TRASH_ERROR`;
export const PERMANENTLY_DELETE_LOADING = `PERMANENTLY_DELETE_LOADING`;
export const PERMANENTLY_DELETE_SUCCESS = `PERMANENTLY_DELETE_SUCCESS`;
export const PERMANENTLY_DELETE_ERROR = `PERMANENTLY_DELETE_ERROR`;

// PREPARE DOWNLOAD ALL ATTACHMENTS
export const PREPARING_DOWNLOAD_ALL_ATTACHMENTS_LOADING = `PREPARING_DOWNLOAD_ALL_ATTACHMENTS_LOADING`;
export const PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS = `PREPARING_DOWNLOAD_ALL_ATTACHMENTS_SUCCESS`;
export const PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR = `PREPARING_DOWNLOAD_ALL_ATTACHMENTS_ERROR`;

// FORM_DRAFTS
export const SAVE_FORM_DRAFT = `SAVE_FORM_DRAFT`;
export const REMOVE_FORM_DRAFT = `REMOVE_FORM_DRAFT`;
export const SET_FORM_OPEN = `SET_FORM_OPEN`;
export const SET_FORM_CLOSED = `SET_FORM_CLOSED`;
export const UPDATE_FORM_DRAFT_TIMESTAMP = `UPDATE_FORM_DRAFT_TIMESTAMP`;

// FORM REQUEST RETRIES
export const RETRY_SUBMIT_COMMENT_LOADING = `RETRY_SUBMIT_COMMENT_LOADING`;

export const SEND_REQUEST = `SEND_REQUEST`;
export const REQUEST_FAILED = `REQUEST_FAILED`;

export const TASK_COMPLETED = `TASK_COMPLETED`;

//REPORTS
export const FETCH_REPORTS_TIME_RECORDS_LOADING = `FETCH_REPORTS_TIME_RECORDS_LOADING`;
export const FETCH_REPORTS_TIME_RECORDS_SUCCESS = `FETCH_REPORTS_TIME_RECORDS_SUCCESS`;
export const FETCH_REPORTS_TIME_RECORDS_ERROR = `FETCH_REPORTS_TIME_RECORDS_ERROR`;

// JOB_TYPES
export const FETCH_JOB_TYPE_LOADING = `FETCH_JOB_TYPE_LOADING`;
export const FETCH_JOB_TYPE_SUCCESS = `FETCH_JOB_TYPE_SUCCESS`;
export const FETCH_JOB_TYPE_ERROR = `FETCH_JOB_TYPE_ERROR`;
export const FETCH_JOB_TYPES_LOADING = `FETCH_JOB_TYPES_LOADING`;
export const FETCH_JOB_TYPES_SUCCESS = `FETCH_JOB_TYPES_SUCCESS`;
export const FETCH_JOB_TYPES_ERROR = `FETCH_JOB_TYPES_ERROR`;

export const ADD_JOB_TYPE_LOADING = `ADD_JOB_TYPE_LOADING`;
export const ADD_JOB_TYPE_SUCCESS = `ADD_JOB_TYPE_SUCCESS`;
export const ADD_JOB_TYPE_ERROR = `ADD_JOB_TYPE_ERROR`;
export const EDIT_JOB_TYPE_LOADING = `EDIT_JOB_TYPE_LOADING`;
export const EDIT_JOB_TYPE_SUCCESS = `EDIT_JOB_TYPE_SUCCESS`;
export const EDIT_JOB_TYPE_ERROR = `EDIT_JOB_TYPE_ERROR`;
export const DELETE_JOB_TYPE_LOADING = `DELETE_JOB_TYPE_LOADING`;
export const DELETE_JOB_TYPE_SUCCESS = `DELETE_JOB_TYPE_SUCCESS`;
export const DELETE_JOB_TYPE_ERROR = `DELETE_JOB_TYPE_ERROR`;
export const DELETE_JOB_TYPE_FROM_EVENT_STREAM = `DELETE_JOB_TYPE_FROM_EVENT_STREAM`;
export const SET_BATCH_JOB_TYPES_LOADING = `SET_BATCH_JOB_TYPES_LOADING`;
export const SET_BATCH_JOB_TYPES_SUCCESS = `SET_BATCH_JOB_TYPES_SUCCESS`;
export const SET_BATCH_JOB_TYPES_ERROR = `SET_BATCH_JOB_TYPES_ERROR`;

export const FETCH_USER_JOB_TYPES_LOADING = "FETCH_USER_JOB_TYPES_LOADING";
export const FETCH_USER_JOB_TYPES_SUCCESS = "FETCH_USER_JOB_TYPES_SUCCESS";
export const FETCH_USER_JOB_TYPES_ERROR = "FETCH_USER_JOB_TYPES_ERROR";

// LAST VISIT
export const FETCH_LAST_VISIT_LOADING = `FETCH_LAST_VISIT_LOADING`;
export const FETCH_LAST_VISIT_SUCCESS = `FETCH_LAST_VISIT_SUCCESS`;
export const FETCH_LAST_VISIT_ERROR = `FETCH_LAST_VISIT_ERROR`;
export const SET_COMMENT_LIST_TOP_IN_VIEWPORT = `SET_COMMENT_LIST_TOP_IN_VIEWPORT`;

// TASK_FILTERS
export const SET_TASK_FILTER_LOADING = `SET_TASK_FILTER_LOADING`;
export const SET_TASK_FILTER_ERROR = `SET_TASK_FILTER_ERROR`;
export const SET_TASK_FILTER_SUCCESS = `SET_TASK_FILTER_SUCCESS`;
export const UNSET_TASK_FILTERS_LOADING = `UNSET_TASK_FILTERS_LOADING`;
export const UNSET_TASK_FILTERS_ERROR = `UNSET_TASK_FILTERS_ERROR`;
export const UNSET_TASK_FILTERS_SUCCESS = `UNSET_TASK_FILTERS_SUCCESS`;

// ANGULAR EVENTS GENERIC actions
export const ANGULAR_INIT = `ANGULAR_INIT`;
export const ANGULAR_INIT_OTHER = `ANGULAR_INIT_OTHER`;
export const ANGULAR_INITIALIZE_TASKS = `ANGULAR_INITIALIZE_TASKS`;
export const ANGULAR_INIT_TASK_AND_COMMENTS_MODAL = `ANGULAR_INIT_TASK_AND_COMMENTS_MODAL`;
export const ANGULAR_INIT_PROJECT_MODAL = `ANGULAR_INIT_PROJECT_MODAL`;
export const ANGULAR_ADD_TIME_RECORD = `ANGULAR_ADD_TIME_RECORD`;
export const ANGULAR_EDIT_TIME_RECORD = `ANGULAR_EDIT_TIME_RECORD`;
export const ANGULAR_COPY_MOVE_TASK_TO_PROJECT = `ANGULAR_COPY_MOVE_TASK_TO_PROJECT`;
export const ANGULAR_INIT_CACHED_TASK_FROM_ANGULAR = `ANGULAR_INIT_CACHED_TASK_FROM_ANGULAR`;

// ACCOUNT SETTINGS
export const FETCH_ACCOUNT_SETTINGS_LOADING = `FETCH_ACCOUNT_SETTINGS_LOADING`;
export const FETCH_ACCOUNT_SETTINGS_SUCCESS = `FETCH_ACCOUNT_SETTINGS_SUCCESS`;
export const FETCH_ACCOUNT_SETTINGS_ERROR = `FETCH_ACCOUNT_SETTINGS_ERROR`;

export const FETCH_ACCOUNT_USED_STORAGE_LOADING = `FETCH_ACCOUNT_USED_STORAGE_LOADING`;
export const FETCH_ACCOUNT_USED_STORAGE_SUCCESS = `FETCH_ACCOUNT_USED_STORAGE_SUCCESS`;
export const FETCH_ACCOUNT_USED_STORAGE_ERROR = `FETCH_ACCOUNT_USED_STORAGE_ERROR`;

// SAMPLE PROJECTS
export const FETCH_SAMPLE_PROJECTS_LOADING = `FETCH_SAMPLE_PROJECTS_LOADING`;
export const FETCH_SAMPLE_PROJECTS_SUCCESS = `FETCH_SAMPLE_PROJECTS_SUCCESS`;
export const FETCH_SAMPLE_PROJECTS_ERROR = `FETCH_SAMPLE_PROJECTS_ERROR`;

export const IMPORT_SAMPLE_PROJECTS_LOADING = `IMPORT_SAMPLE_PROJECTS_LOADING`;
export const IMPORT_SAMPLE_PROJECTS_SUCCESS = `IMPORT_SAMPLE_PROJECTS_SUCCESS`;
export const IMPORT_SAMPLE_PROJECTS_ERROR = `IMPORT_SAMPLE_PROJECTS_ERROR`;

// SETUP WIZARD
export const SET_PASSWORD_LOADING = `SET_PASSWORD_LOADING`;
export const SET_PASSWORD_SUCCESS = `SET_PASSWORD_SUCCESS`;
export const SET_PASSWORD_ERROR = `SET_PASSWORD_ERROR`;
export const SETUP_WIZARD_FEATURES_SHOWN = `SETUP_WIZARD_FEATURES_SHOWN`;

// CANCEL SUBSCRIPTION
export const GET_ACCOUNT_STATS_BEFORE_CANCELLATION_LOADING = `GET_ACCOUNT_STATS_BEFORE_CANCELLATION_LOADING`;
export const GET_ACCOUNT_STATS_BEFORE_CANCELLATION_SUCCESS = `GET_ACCOUNT_STATS_BEFORE_CANCELLATION_SUCCESS`;
export const GET_ACCOUNT_STATS_BEFORE_CANCELLATION_ERROR = `GET_ACCOUNT_STATS_BEFORE_CANCELLATION_ERROR`;

export const CREATE_CANCELLATION_REQUEST_LOADING = `CREATE_CANCELLATION_REQUEST_LOADING`;
export const CREATE_CANCELLATION_REQUEST_SUCCESS = `CREATE_CANCELLATION_REQUEST_SUCCESS`;
export const CREATE_CANCELLATION_REQUEST_ERROR = `CREATE_CANCELLATION_REQUEST_ERROR`;

export const VERIFY_PASSWORD_LOADING = `VERIFY_PASSWORD_LOADING`;
export const VERIFY_PASSWORD_SUCCESS = `VERIFY_PASSWORD_SUCCESS`;
export const VERIFY_PASSWORD_ERROR = `VERIFY_PASSWORD_ERROR`;

// SUBSCRIPTION PLANS
export const FETCH_SUBSCRIPTION_PLANS_LOADING = `FETCH_SUBSCRIPTION_PLANS_LOADING`;
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS = `FETCH_SUBSCRIPTION_PLANS_SUCCESS`;
export const FETCH_SUBSCRIPTION_PLANS_ERROR = `FETCH_SUBSCRIPTION_PLANS_ERROR`;

// SUBSCRIPTION ADD-ONS
export const FETCH_SUBSCRIPTION_ADD_ONS_LOADING = `FETCH_SUBSCRIPTION_ADD_ONS_LOADING`;
export const FETCH_SUBSCRIPTION_ADD_ONS_SUCCESS = `FETCH_SUBSCRIPTION_ADD_ONS_SUCCESS`;
export const FETCH_SUBSCRIPTION_ADD_ONS_ERROR = `FETCH_SUBSCRIPTION_ADD_ONS_ERROR`;

export const DISABLE_SUBSCRIPTION_ADD_ON_LOADING = `DISABLE_SUBSCRIPTION_ADD_ON_LOADING`;
export const DISABLE_TO_SUBSCRIPTION_ADD_ON_SUCCESS = `DISABLE_TO_SUBSCRIPTION_ADD_ON_SUCCESS`;
export const DISABLE_TO_SUBSCRIPTION_ADD_ON_ERROR = `DISABLE_TO_SUBSCRIPTION_ADD_ON_ERROR`;

export const TRY_SUBSCRIPTION_ADD_ON_LOADING = `TRY_SUBSCRIPTION_ADD_ON_LOADING`;
export const TRY_SUBSCRIPTION_ADD_ON_SUCCESS = `TRY_SUBSCRIPTION_ADD_ON_SUCCESS`;
export const TRY_SUBSCRIPTION_ADD_ON_ERROR = `TRY_SUBSCRIPTION_ADD_ON_ERROR`;

// ALL COUNTRIES
export const FETCH_COUNTRIES_LOADING = `FETCH_COUNTRIES_LOADING`;
export const FETCH_COUNTRIES_SUCCESS = `FETCH_COUNTRIES_SUCCESS`;
export const FETCH_COUNTRIES_ERROR = `FETCH_COUNTRIES_ERROR`;

// STATES FOR COUNTRIES
export const FETCH_COUNTRY_STATES_LOADING = `FETCH_COUNTRY_STATES_LOADING`;
export const FETCH_COUNTRY_STATES_SUCCESS = `FETCH_COUNTRY_STATES_SUCCESS`;
export const FETCH_COUNTRY_STATES_ERROR = `FETCH_COUNTRY_STATES_ERROR`;

// ALL EU COUNTRIES
export const FETCH_EU_COUNTRIES_LOADING = `FETCH_EU_COUNTRIES_LOADING`;
export const FETCH_EU_COUNTRIES_SUCCESS = `FETCH_EU_COUNTRIES_SUCCESS`;
export const FETCH_EU_COUNTRIES_ERROR = `FETCH_EU_COUNTRIES_ERROR`;

// SUBSCRIPTION ORDERS
export const SWITCH_TO_SUBSCRIPTION_PLAN_LOADING = `SWITCH_TO_SUBSCRIPTION_PLAN_LOADING`;
export const SWITCH_TO_SUBSCRIPTION_PLAN_SUCCESS = `SWITCH_TO_SUBSCRIPTION_PLAN_SUCCESS`;
export const SWITCH_TO_SUBSCRIPTION_PLAN_ERROR = `SWITCH_TO_SUBSCRIPTION_PLAN_ERROR`;
export const SWITCH_IS_MONTHLY = `SWITCH_IS_MONTHLY`;

// BILLING ORDER
export const FETCH_BILLING_ORDER_LOADING = `FETCH_BILLING_ORDER_LOADING`;
export const FETCH_BILLING_ORDER_SUCCESS = `FETCH_BILLING_ORDER_SUCCESS`;
export const FETCH_BILLING_ORDER_ERROR = `FETCH_BILLING_ORDER_ERROR`;

export const EDIT_BILLING_ORDER_LOADING = `EDIT_BILLING_ORDER_LOADING`;
export const EDIT_BILLING_ORDER_SUCCESS = `EDIT_BILLING_ORDER_SUCCESS`;
export const EDIT_BILLING_ORDER_ERROR = `EDIT_BILLING_ORDER_ERROR`;

export const COMPLETE_BILLING_ORDER_LOADING = `COMPLETE_BILLING_ORDER_LOADING`;
export const COMPLETE_BILLING_ORDER_SUCCESS = `COMPLETE_BILLING_ORDER_SUCCESS`;
export const COMPLETE_BILLING_ORDER_ERROR = `COMPLETE_BILLING_ORDER_ERROR`;
export const CLOSE_BILLING_ORDER_PROCESSING_SCREEN = `CLOSE_BILLING_ORDER_PROCESSING_SCREEN`;

export const SET_BILLING_ORDER_STEP = `SET_BILLING_ORDER_STEP`;

export const FETCH_THANK_YOU_LOADING = `FETCH_THANK_YOU_LOADING`;
export const FETCH_THANK_YOU_SUCCESS = `FETCH_THANK_YOU_SUCCESS`;
export const FETCH_THANK_YOU_ERROR = `FETCH_THANK_YOU_ERROR`;

// BILLING PAYMENT METHOD
export const FETCH_BILLING_PAYMENT_METHOD_LOADING = `FETCH_BILLING_PAYMENT_METHOD_LOADING`;
export const FETCH_BILLING_PAYMENT_METHOD_SUCCESS = `FETCH_BILLING_PAYMENT_METHOD_SUCCESS`;
export const FETCH_BILLING_PAYMENT_METHOD_ERROR = `FETCH_BILLING_PAYMENT_METHOD_ERROR`;

export const SET_PAYMENT_METHOD_TYPE = `SET_PAYMENT_METHOD_TYPE`;

// BILLING ADDRESS
export const ADD_BILLING_ADDRESS_LOADING = `ADD_BILLING_ADDRESS_LOADING`;
export const ADD_BILLING_ADDRESS_SUCCESS = `ADD_BILLING_ADDRESS_SUCCESS`;
export const ADD_BILLING_ADDRESS_ERROR = `ADD_BILLING_ADDRESS_ERROR`;

export const EDIT_BILLING_ADDRESS_LOADING = `EDIT_BILLING_ADDRESS_LOADING`;
export const EDIT_BILLING_ADDRESS_SUCCESS = `EDIT_BILLING_ADDRESS_SUCCESS`;
export const EDIT_BILLING_ADDRESS_ERROR = `EDIT_BILLING_ADDRESS_ERROR`;

export const TAX_RATES_CHECK_LOADING = `TAX_RATES_CHECK_LOADING`;
export const TAX_RATES_CHECK_SUCCESS = `TAX_RATES_CHECK_SUCCESS`;
export const TAX_RATES_CHECK_ERROR = `TAX_RATES_CHECK_ERROR`;

// STRIPE TOKEN
export const CREATE_STRIPE_TOKEN_LOADING = `CREATE_STRIPE_TOKEN_LOADING`;
export const CREATE_STRIPE_TOKEN_SUCCESS = `CREATE_STRIPE_TOKEN_SUCCESS`;
export const CREATE_STRIPE_TOKEN_ERROR = `CREATE_STRIPE_TOKEN_ERROR`;

// SUBSCRIPTION
export const FETCH_ALL_INVOICES_LOADING = `FETCH_ALL_INVOICES_LOADING`;
export const FETCH_ALL_INVOICES_SUCCESS = `FETCH_ALL_INVOICES_SUCCESS`;
export const FETCH_ALL_INVOICES_ERROR = `FETCH_ALL_INVOICES_ERROR`;

// STOP RETIREMENT
export const STOP_RETIREMENT_LOADING = `STOP_RETIREMENT_LOADING`;
export const STOP_RETIREMENT_SUCCESS = `STOP_RETIREMENT_SUCCESS`;
export const STOP_RETIREMENT_ERROR = `STOP_RETIREMENT_ERROR`;

export const CLEAR_HTTP_MESSAGES = `CLEAR_HTTP_MESSAGES`;
export const ADD_ERROR_MESSAGE = `ADD_ERROR_MESSAGE`;
export const ADD_SUCCESS_MESSAGE = `ADD_SUCCESS_MESSAGE`;

// PROJECT BUDGET
export const FETCH_PROJECT_BUDGET_LOADING = `FETCH_PROJECT_BUDGET_LOADING`;
export const FETCH_PROJECT_BUDGET_SUCCESS = `FETCH_PROJECT_BUDGET_SUCCESS`;
export const FETCH_PROJECT_BUDGET_ERROR = `FETCH_PROJECT_BUDGET_ERROR`;

// ACCOUNT BALANCE
export const FETCH_ACCOUNT_BALANCE_LOADING = `FETCH_ACCOUNT_BALANCE_LOADING`;
export const FETCH_ACCOUNT_BALANCE_SUCCESS = `FETCH_ACCOUNT_BALANCE_SUCCESS`;
export const FETCH_ACCOUNT_BALANCE_ERROR = `FETCH_ACCOUNT_BALANCE_ERROR`;

export const FETCH_RECORDED_BALANCE_LOADING = `FETCH_RECORDED_BALANCE_LOADING`;
export const FETCH_RECORDED_BALANCE_SUCCESS = `FETCH_RECORDED_BALANCE_SUCCESS`;
export const FETCH_RECORDED_BALANCE_ERROR = `FETCH_RECORDED_BALANCE_ERROR`;

// ACCOUNT SUSPENDED
export const REQUEST_ACCESS_WHEN_ACCOUNT_IS_SUSPENDED_LOADING = `REQUEST_ACCESS_WHEN_ACCOUNT_IS_SUSPENDED_LOADING`;
export const REQUEST_ACCESS_WHEN_ACCOUNT_IS_SUSPENDED_SUCCESS = `REQUEST_ACCESS_WHEN_ACCOUNT_IS_SUSPENDED_SUCCESS`;
export const REQUEST_ACCESS_WHEN_ACCOUNT_IS_SUSPENDED_ERROR = `REQUEST_ACCESS_WHEN_ACCOUNT_IS_SUSPENDED_ERROR`;

// REACTIONS
export const ADD_REACTION_LOADING = `ADD_REACTION_LOADING`;
export const ADD_REACTION_SUCCESS = `ADD_REACTION_SUCCESS`;
export const ADD_REACTION_ERROR = `ADD_REACTION_ERROR`;

export const REMOVE_REACTION_LOADING = `REMOVE_REACTION_LOADING`;
export const REMOVE_REACTION_SUCCESS = `REMOVE_REACTION_SUCCESS`;
export const REMOVE_REACTION_ERROR = `REMOVE_REACTION_ERROR`;

export const FETCH_AVAILABLE_REACTIONS_SUCCESS = `FETCH_AVAILABLE_REACTIONS_SUCCESS`;
export const FETCH_MY_WORK_REACTIONS = `FETCH_MY_WORK_REACTIONS`;
export const ADD_REACTION_FROM_EVENT_STREAM_SUCCESS = `ADD_REACTION_FROM_EVENT_STREAM_SUCCESS`;
export const REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS = `REMOVE_REACTION_FROM_EVENT_STREAM_SUCCESS`;

// ADDITIONAL OBJECT DATA
export const CLEAR_OBJECT_HAS_NEW_COMMENTS = `CLEAR_OBJECT_HAS_NEW_COMMENTS`;

// BLOCKING INTERFACE
export const SET_THANK_YOU_PAGE_VISIBILITY = `SET_THANK_YOU_PAGE_VISIBILITY`;

// REALTIME
export const REALTIME_CONNECTION_STATE_CHANGE = `REALTIME_CONNECTION_STATE_CHANGE`;
export const DATA_OBJECT_DELETED_LOADING = `DATA_OBJECT_DELETED_LOADING`;
export const DATA_OBJECT_DELETED_SUCCESS = `DATA_OBJECT_DELETED_SUCCESS`;
export const DATA_OBJECT_DELETED_ERROR = `DATA_OBJECT_DELETED_ERROR`;

// DAYS OFF
export const FETCH_DAYS_OFF_LOADING = `FETCH_DAYS_OFF_LOADING`;
export const FETCH_DAYS_OFF_SUCCESS = `FETCH_DAYS_OFF_SUCCESS`;
export const FETCH_DAYS_OFF_ERROR = `FETCH_DAYS_OFF_ERROR`;
export const ADD_DAYS_OFF_LOADING = `ADD_DAYS_OFF_LOADING`;
export const ADD_DAYS_OFF_SUCCESS = `ADD_DAYS_OFF_SUCCESS`;
export const ADD_DAYS_OFF_ERROR = `ADD_DAYS_OFF_ERROR`;
export const EDIT_DAYS_OFF_LOADING = `EDIT_DAYS_OFF_LOADING`;
export const EDIT_DAYS_OFF_SUCCESS = `EDIT_DAYS_OFF_SUCCESS`;
export const EDIT_DAYS_OFF_ERROR = `EDIT_DAYS_OFF_ERROR`;
export const DELETE_DAYS_OFF_LOADING = `DELETE_DAYS_OFF_LOADING`;
export const DELETE_DAYS_OFF_SUCCESS = `DELETE_DAYS_OFF_SUCCESS`;
export const DELETE_DAYS_OFF_ERROR = `DELETE_DAYS_OFF_ERROR`;

// PROJECT TEMPLATES
export const ADD_PROJECT_TEMPLATE_LOADING = "ADD_PROJECT_TEMPLATE_LOADING";
export const ADD_PROJECT_TEMPLATE_SUCCESS = "ADD_PROJECT_TEMPLATE_SUCCESS";
export const ADD_PROJECT_TEMPLATE_ERROR = "ADD_PROJECT_TEMPLATE_ERROR";
export const EDIT_PROJECT_TEMPLATE_LOADING = "EDIT_PROJECT_TEMPLATE_LOADING";
export const EDIT_PROJECT_TEMPLATE_SUCCESS = "EDIT_PROJECT_TEMPLATE_SUCCESS";
export const EDIT_PROJECT_TEMPLATE_ERROR = "EDIT_PROJECT_TEMPLATE_ERROR";
export const FETCH_PROJECT_TEMPLATE_LOADING = "FETCH_PROJECT_TEMPLATE_LOADING";
export const FETCH_PROJECT_TEMPLATE_SUCCESS = "FETCH_PROJECT_TEMPLATE_SUCCESS";
export const FETCH_PROJECT_TEMPLATE_ERROR = "FETCH_PROJECT_TEMPLATE_ERROR";
export const FETCH_PROJECT_TEMPLATES_LOADING = "FETCH_PROJECT_TEMPLATES_LOADING";
export const FETCH_PROJECT_TEMPLATES_SUCCESS = "FETCH_PROJECT_TEMPLATES_SUCCESS";
export const FETCH_PROJECT_TEMPLATES_ERROR = "FETCH_PROJECT_TEMPLATES_ERROR";
export const MOVE_PROJECT_TEMPLATE_TO_TRASH_LOADING = "MOVE_PROJECT_TEMPLATE_TO_TRASH_LOADING";
export const MOVE_PROJECT_TEMPLATE_TO_TRASH_SUCCESS = "MOVE_PROJECT_TEMPLATE_TO_TRASH_SUCCESS";
export const MOVE_PROJECT_TEMPLATE_TO_TRASH_ERROR = "MOVE_PROJECT_TEMPLATE_TO_TRASH_ERROR";
export const DUPLICATE_PROJECT_TEMPLATE_LOADING = "DUPLICATE_PROJECT_TEMPLATE_LOADING";
export const DUPLICATE_PROJECT_TEMPLATE_SUCCESS = "DUPLICATE_PROJECT_TEMPLATE_SUCCESS";
export const DUPLICATE_PROJECT_TEMPLATE_ERROR = "DUPLICATE_PROJECT_TEMPLATE_ERROR";
export const ADD_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS = "ADD_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS";
export const EDIT_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS = "EDIT_PROJECT_TEMPLATE_FROM_EVENT_STREAM_SUCCESS";
export const PROJECT_TEMPLATE_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS =
  "PROJECT_TEMPLATE_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS";
export const PROJECT_TEMPLATE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS =
  "PROJECT_TEMPLATE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM_SUCCESS";

// PROJECT TEMPLATE TASK DEPENDENCIES
export const FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING = `FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING`;
export const FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS = `FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS`;
export const FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR = `FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR`;
export const FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_LOADING = `FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_LOADING`;
export const FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS = `FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS`;
export const FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_ERROR = `FETCH_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUGGESTIONS_ERROR`;
export const ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING = `ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING`;
export const ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS = `ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS`;
export const ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR = `ADD_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR`;
export const DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING = `DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_LOADING`;
export const DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS = `DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_SUCCESS`;
export const DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR = `DELETE_PROJECT_TEMPLATE_TASK_DEPENDENCIES_ERROR`;
export const MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_LOADING = `MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_LOADING`;
export const MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_SUCCESS = `MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_SUCCESS`;
export const MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_ERROR = `MOVE_TO_LIST_PROJECT_TEMPLATE_TASK_ERROR`;

// PROJECT TEMPLATE ELEMENTS
export const FETCH_PROJECT_TEMPLATE_ELEMENTS_LOADING = `FETCH_PROJECT_TEMPLATE_ELEMENTS_LOADING`;
export const FETCH_PROJECT_TEMPLATE_ELEMENTS_SUCCESS = `FETCH_PROJECT_TEMPLATE_ELEMENTS_SUCCESS`;
export const FETCH_PROJECT_TEMPLATE_ELEMENTS_ERROR = `FETCH_PROJECT_TEMPLATE_ELEMENTS_ERROR`;
export const FETCH_PROJECT_TEMPLATE_ELEMENT_LOADING = `FETCH_PROJECT_TEMPLATE_ELEMENT_LOADING`;
export const FETCH_PROJECT_TEMPLATE_ELEMENT_SUCCESS = `FETCH_PROJECT_TEMPLATE_ELEMENT_SUCCESS`;
export const FETCH_PROJECT_TEMPLATE_ELEMENT_ERROR = `FETCH_PROJECT_TEMPLATE_ELEMENT_ERROR`;
export const DELETE_PROJECT_TEMPLATE_ELEMENT_LOADING = `DELETE_PROJECT_TEMPLATE_ELEMENT_LOADING`;
export const DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS = `DELETE_PROJECT_TEMPLATE_ELEMENT_SUCCESS`;
export const DELETE_PROJECT_TEMPLATE_ELEMENT_ERROR = `DELETE_PROJECT_TEMPLATE_ELEMENT_ERROR`;
export const ADD_PROJECT_TEMPLATE_ELEMENT_LOADING = `ADD_PROJECT_TEMPLATE_ELEMENT_LOADING`;
export const ADD_PROJECT_TEMPLATE_ELEMENT_SUCCESS = `ADD_PROJECT_TEMPLATE_ELEMENT_SUCCESS`;
export const ADD_PROJECT_TEMPLATE_ELEMENT_ERROR = `ADD_PROJECT_TEMPLATE_ELEMENT_ERROR`;
export const EDIT_PROJECT_TEMPLATE_ELEMENT_LOADING = `EDIT_PROJECT_TEMPLATE_ELEMENT_LOADING`;
export const EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS = `EDIT_PROJECT_TEMPLATE_ELEMENT_SUCCESS`;
export const EDIT_PROJECT_TEMPLATE_ELEMENT_ERROR = `EDIT_PROJECT_TEMPLATE_ELEMENT_ERROR`;
export const REORDER_PROJECT_TEMPLATE_LISTS_LOADING = `REORDER_PROJECT_TEMPLATE_LISTS_LOADING`;
export const REORDER_PROJECT_TEMPLATE_LISTS_SUCCESS = `REORDER_PROJECT_TEMPLATE_LISTS_SUCCESS`;
export const REORDER_PROJECT_TEMPLATE_LISTS_ERROR = `REORDER_PROJECT_TEMPLATE_LISTS_ERROR`;
export const REORDER_PROJECT_TEMPLATE_ELEMENTS_LOADING = `REORDER_PROJECT_TEMPLATE_ELEMENTS_LOADING`;
export const REORDER_PROJECT_TEMPLATE_ELEMENTS_SUCCESS = `REORDER_PROJECT_TEMPLATE_ELEMENTS_SUCCESS`;
export const REORDER_PROJECT_TEMPLATE_ELEMENTS_ERROR = `REORDER_PROJECT_TEMPLATE_ELEMENTS_ERROR`;
export const BATCH_ADD_PROJECT_TEMPLATE_FILES_LOADING = `BATCH_ADD_PROJECT_TEMPLATE_FILES_LOADING`;
export const BATCH_ADD_PROJECT_TEMPLATE_FILES_SUCCESS = `BATCH_ADD_PROJECT_TEMPLATE_FILES_SUCCESS`;
export const BATCH_ADD_PROJECT_TEMPLATE_FILES_ERROR = `BATCH_ADD_PROJECT_TEMPLATE_FILES_ERROR`;
export const UNASSIGN_CLIENT_FROM_PROJECT_TEMPLATE_SUBTASKS = `UNASSIGN_CLIENT_FROM_PROJECT_TEMPLATE_SUBTASKS`;

//STOPWATCH
export const STOPWATCH_START_LOADING = `STOPWATCH_START_LOADING`;
export const STOPWATCH_START_SUCCESS = `STOPWATCH_START_SUCCESS`;
export const STOPWATCH_START_ERROR = `STOPWATCH_START_ERROR`;
export const STOPWATCH_PAUSE_LOADING = `STOPWATCH_PAUSE_LOADING`;
export const STOPWATCH_PAUSE_SUCCESS = `STOPWATCH_PAUSE_SUCCESS`;
export const STOPWATCH_PAUSE_ERROR = `STOPWATCH_PAUSE_ERROR`;
export const STOPWATCHES_FETCH_LOADING = `STOPWATCHES_FETCH_LOADING`;
export const STOPWATCHES_FETCH_SUCCESS = `STOPWATCHES_FETCH_SUCCESS`;
export const STOPWATCHES_FETCH_ERROR = `STOPWATCHES_FETCH_ERROR`;
export const STOPWATCH_STARTED_FROM_EVENT_STREAM = `STOPWATCH_STARTED_FROM_EVENT_STREAM`;
export const STOPWATCH_UPDATED_FROM_EVENT_STREAM = `STOPWATCH_UPDATED_FROM_EVENT_STREAM`;
export const STOPWATCH_DELETED_FROM_EVENT_STREAM = `STOPWATCH_DELETED_FROM_EVENT_STREAM`;
export const STOPWATCH_RESUME_LOADING = `STOPWATCH_RESUME_LOADING`;
export const STOPWATCH_RESUME_SUCCESS = `STOPWATCH_RESUME_SUCCESS`;
export const STOPWATCH_RESUME_ERROR = `STOPWATCH_RESUME_ERROR`;
export const STOPWATCH_DELETE_LOADING = `STOPWATCH_DELETE_LOADING`;
export const STOPWATCH_DELETE_SUCCESS = `STOPWATCH_DELETE_SUCCESS`;
export const STOPWATCH_DELETE_ERROR = `STOPWATCH_DELETE_ERROR`;
export const STOPWATCH_EDIT_LOADING = `STOPWATCH_EDIT_LOADING`;
export const STOPWATCH_EDIT_SUCCESS = `STOPWATCH_EDIT_SUCCESS`;
export const STOPWATCH_EDIT_ERROR = `STOPWATCH_EDIT_ERROR`;
export const STOPWATCH_MERGE_LOADING = `STOPWATCH_MERGE_LOADING`;
export const STOPWATCH_MERGE_SUCCESS = `STOPWATCH_MERGE_SUCCESS`;
export const STOPWATCH_MERGE_ERROR = `STOPWATCH_MERGE_ERROR`;
export const STOPWATCHES_FETCH_OFFSET_LOADING = `STOPWATCHES_FETCH_OFFSET_LOADING`;
export const STOPWATCHES_FETCH_OFFSET_SUCCESS = `STOPWATCHES_FETCH_OFFSET_SUCCESS`;
export const STOPWATCHES_FETCH_OFFSET_ERROR = `STOPWATCHES_FETCH_OFFSET_ERROR`;

// WORKLOAD
export const FETCH_WORKLOAD_TASKS_LOADING = `FETCH_WORKLOAD_TASKS_LOADING`;
export const FETCH_WORKLOAD_TASKS_SUCCESS = `FETCH_WORKLOAD_TASKS_SUCCESS`;
export const FETCH_WORKLOAD_TASKS_ERROR = `FETCH_WORKLOAD_TASKS_ERROR`;
export const FETCH_WORKLOAD_PROJECTS_LOADING = `FETCH_WORKLOAD_PROJECTS_LOADING`;
export const FETCH_WORKLOAD_PROJECTS_SUCCESS = `FETCH_WORKLOAD_PROJECTS_SUCCESS`;
export const FETCH_WORKLOAD_PROJECTS_ERROR = `FETCH_WORKLOAD_PROJECTS_ERROR`;
export const SET_WORKLOAD_USER_FILTER = `SET_WORKLOAD_USER_FILTER`;
export const WORKLOAD_TOGGLE_COMPLETED_TASKS = `WORKLOAD_TOGGLE_COMPLETED_TASKS`;
export const FETCH_GHOST_TASKS_LOADING = `FETCH_GHOST_TASKS_LOADING`;
export const FETCH_GHOST_TASKS_SUCCESS = `FETCH_GHOST_TASKS_SUCCESS`;
export const FETCH_GHOST_TASKS_ERROR = `FETCH_GHOST_TASKS_ERROR`;
export const FETCH_WORKLOAD_SUBTASKS_LOADING = `FETCH_WORKLOAD_SUBTASKS_LOADING`;
export const FETCH_WORKLOAD_SUBTASKS_SUCCESS = `FETCH_WORKLOAD_SUBTASKS_SUCCESS`;
export const FETCH_WORKLOAD_SUBTASKS_ERROR = `FETCH_WORKLOAD_SUBTASKS_ERROR`;
export const FETCH_WORKLOAD_CALENDAR_EVENTS_LOADING = `FETCH_WORKLOAD_CALENDAR_EVENTS_LOADING`;
export const FETCH_WORKLOAD_CALENDAR_EVENTS_SUCCESS = `FETCH_WORKLOAD_CALENDAR_EVENTS_SUCCESS`;
export const FETCH_WORKLOAD_CALENDAR_EVENTS_ERROR = `FETCH_WORKLOAD_CALENDAR_EVENTS_ERROR`;

// TIME RECORDS
export const FETCH_TIME_RECORDS_LOADING = `FETCH_TIME_RECORDS_LOADING`;
export const FETCH_TIME_RECORDS_SUCCESS = `FETCH_TIME_RECORDS_SUCCESS`;
export const FETCH_TIME_RECORDS_ERROR = `FETCH_TIME_RECORDS_ERROR`;
export const FETCH_PROJECT_LIST_TIME_RECORDS_LOADING = `FETCH_PROJECT_LIST_TIME_RECORDS_LOADING`;
export const FETCH_PROJECT_LIST_TIME_RECORDS_SUCCESS = `FETCH_PROJECT_LIST_TIME_RECORDS_SUCCESS`;
export const FETCH_PROJECT_LIST_TIME_RECORDS_ERROR = `FETCH_PROJECT_LIST_TIME_RECORDS_ERROR`;
export const ADD_TIME_RECORD_LOADING = `ADD_TIME_RECORD_LOADING`;
export const ADD_TIME_RECORD_SUCCESS = `ADD_TIME_RECORD_SUCCESS`;
export const ADD_TIME_RECORD_ERROR = `ADD_TIME_RECORD_ERROR`;
export const EDIT_TIME_RECORD_LOADING = `EDIT_TIME_RECORD_LOADING`;
export const EDIT_TIME_RECORD_SUCCESS = `EDIT_TIME_RECORD_SUCCESS`;
export const EDIT_TIME_RECORD_ERROR = `EDIT_TIME_RECORD_ERROR`;
export const DELETE_TIME_RECORD_LOADING = `DELETE_TIME_RECORD_LOADING`;
export const DELETE_TIME_RECORD_SUCCESS = `DELETE_TIME_RECORD_SUCCESS`;
export const DELETE_TIME_RECORD_ERROR = `DELETE_TIME_RECORD_ERROR`;
export const TIME_RECORD_CREATED_FROM_EVENT_STREAM = `TIME_RECORD_CREATED_FROM_EVENT_STREAM`;
export const TIME_RECORD_UPDATED_FROM_EVENT_STREAM = `TIME_RECORD_UPDATED_FROM_EVENT_STREAM`;
export const TIME_RECORD_MOVE_TO_TRASH_FROM_EVENT_STREAM = `TIME_RECORD_MOVE_TO_TRASH_FROM_EVENT_STREAM`;
export const TIME_RECORD_RESTORED_FROM_TRASH_FROM_EVENT_STREAM = `TIME_RECORD_RESTORED_FROM_TRASH_FROM_EVENT_STREAM`;
export const FETCH_PROJECT_TIME_RECORDS_BY_DATES_LOADING = `FETCH_PROJECT_TIME_RECORDS_BY_DATES_LOADING`;
export const FETCH_PROJECT_TIME_RECORDS_BY_DATES_SUCCESS = `FETCH_PROJECT_TIME_RECORDS_BY_DATES_SUCCESS`;
export const FETCH_PROJECT_TIME_RECORDS_BY_DATES_ERROR = `FETCH_PROJECT_TIME_RECORDS_BY_DATES_ERROR`;
export const MOVE_TIME_RECORD_LOADING = `MOVE_TIME_RECORD_LOADING`;
export const MOVE_TIME_RECORD_SUCCESS = `MOVE_TIME_RECORD_SUCCESS`;
export const MOVE_TIME_RECORD_ERROR = `MOVE_TIME_RECORD_ERROR`;
export const BATCH_EDIT_TIME_RECORDS_LOADING = "BATCH_EDIT_TIME_RECORDS_LOADING";
export const BATCH_EDIT_TIME_RECORDS_SUCCESS = "BATCH_EDIT_TIME_RECORDS_SUCCESS";
export const BATCH_EDIT_TIME_RECORDS_ERROR = "BATCH_EDIT_TIME_RECORDS_ERROR";
export const TIME_RECORD_MOVED_TO_PROJECT_FROM_EVENT_STREAM = "TIME_RECORD_MOVED_TO_PROJECT_FROM_EVENT_STREAM";
export const UPDATED_TIME_RECORDS = "UPDATED_TIME_RECORDS";

// TIMESHEET
export const FETCH_TIMESHEET_TIME_RECORDS_LOADING = `FETCH_TIMESHEET_TIME_RECORDS_LOADING`;
export const FETCH_TIMESHEET_TIME_RECORDS_SUCCESS = `FETCH_TIMESHEET_TIME_RECORDS_SUCCESS`;
export const FETCH_TIMESHEET_TIME_RECORDS_ERROR = `FETCH_TIMESHEET_TIME_RECORDS_ERROR`;

// EXPENSES
export const FETCH_EXPENSE_LOADING = `FETCH_EXPENSE_LOADING`;
export const FETCH_EXPENSE_SUCCESS = `FETCH_EXPENSE_SUCCESS`;
export const FETCH_EXPENSE_ERROR = `FETCH_EXPENSE_ERROR`;
export const FETCH_EXPENSES_LOADING = `FETCH_EXPENSES_LOADING`;
export const FETCH_EXPENSES_SUCCESS = `FETCH_EXPENSES_SUCCESS`;
export const FETCH_EXPENSES_ERROR = `FETCH_EXPENSES_ERROR`;
export const ADD_EXPENSE_LOADING = `ADD_EXPENSE_LOADING`;
export const ADD_EXPENSE_SUCCESS = `ADD_EXPENSE_SUCCESS`;
export const ADD_EXPENSE_ERROR = `ADD_EXPENSE_ERROR`;
export const EDIT_EXPENSE_LOADING = `EDIT_EXPENSE_LOADING`;
export const EDIT_EXPENSE_SUCCESS = `EDIT_EXPENSE_SUCCESS`;
export const EDIT_EXPENSE_ERROR = `EDIT_EXPENSE_ERROR`;
export const MOVE_EXPENSE_TO_TRASH_LOADING = `MOVE_EXPENSE_TO_TRASH_LOADING`;
export const MOVE_EXPENSE_TO_TRASH_SUCCESS = `MOVE_EXPENSE_TO_TRASH_SUCCESS`;
export const MOVE_EXPENSE_TO_TRASH_ERROR = `MOVE_EXPENSE_TO_TRASH_ERROR`;
export const EXPENSE_CREATED_FROM_EVENT_STREAM = `EXPENSE_CREATED_FROM_EVENT_STREAM`;
export const EXPENSE_UPDATED_FROM_EVENT_STREAM = `EXPENSE_UPDATED_FROM_EVENT_STREAM`;
export const EXPENSE_MOVE_TO_TRASH_FROM_EVENT_STREAM = `EXPENSE_MOVE_TO_TRASH_FROM_EVENT_STREAM`;
export const EXPENSE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM = `EXPENSE_RESTORED_FROM_TRASH_FROM_EVENT_STREAM`;
export const FETCH_PROJECT_EXPENSES_LOADING = `FETCH_PROJECT_EXPENSES_LOADING`;
export const FETCH_PROJECT_EXPENSES_SUCCESS = `FETCH_PROJECT_EXPENSES_SUCCESS`;
export const FETCH_PROJECT_EXPENSES_ERROR = `FETCH_PROJECT_EXPENSES_ERROR`;
export const MOVE_EXPENSE_LOADING = "MOVE_EXPENSE_LOADING";
export const MOVE_EXPENSE_SUCCESS = "MOVE_EXPENSE_SUCCESS";
export const MOVE_EXPENSE_ERROR = "MOVE_EXPENSE_ERROR";
export const BATCH_EDIT_EXPENSES_LOADING = "BATCH_EDIT_EXPENSES_LOADING";
export const BATCH_EDIT_EXPENSES_SUCCESS = "BATCH_EDIT_EXPENSES_SUCCESS";
export const BATCH_EDIT_EXPENSES_ERROR = "BATCH_EDIT_EXPENSES_ERROR";
export const EXPENSE_MOVED_TO_PROJECT_FROM_EVENT_STREAM = "EXPENSE_MOVED_TO_PROJECT_FROM_EVENT_STREAM";
export const UPDATED_EXPENSES = "UPDATED_EXPENSES";

// CURRENCIES
export const ANGULAR_INIT_CURRENCIES = `ANGULAR_INIT_CURRENCIES`;

// EXPENSE CATEGORIES
// TODO move this to ReactQuery
export const ANGULAR_INIT_EXPENSE_CATEGORIES = `ANGULAR_INIT_EXPENSE_CATEGORIES`;
export const FETCH_EXPENSE_CATEGORY_LOADING = `FETCH_EXPENSE_CATEGORY_LOADING`;
export const FETCH_EXPENSE_CATEGORY_SUCCESS = `FETCH_EXPENSE_CATEGORY_SUCCESS`;
export const FETCH_EXPENSE_CATEGORY_ERROR = `FETCH_EXPENSE_CATEGORY_ERROR`;
export const FETCH_EXPENSE_CATEGORIES_LOADING = `FETCH_EXPENSE_CATEGORIES_LOADING`;
export const FETCH_EXPENSE_CATEGORIES_SUCCESS = `FETCH_EXPENSE_CATEGORIES_SUCCESS`;
export const FETCH_EXPENSE_CATEGORIES_ERROR = `FETCH_EXPENSE_CATEGORIES_ERROR`;
export const ADD_EXPENSE_CATEGORY_LOADING = `ADD_EXPENSE_CATEGORY_LOADING`;
export const ADD_EXPENSE_CATEGORY_SUCCESS = `ADD_EXPENSE_CATEGORY_SUCCESS`;
export const ADD_EXPENSE_CATEGORY_ERROR = `ADD_EXPENSE_CATEGORY_ERROR`;
export const EDIT_EXPENSE_CATEGORY_LOADING = `EDIT_EXPENSE_CATEGORY_LOADING`;
export const EDIT_EXPENSE_CATEGORY_SUCCESS = `EDIT_EXPENSE_CATEGORY_SUCCESS`;
export const EDIT_EXPENSE_CATEGORY_ERROR = `EDIT_EXPENSE_CATEGORY_ERROR`;
export const DELETE_EXPENSE_CATEGORY_LOADING = `DELETE_EXPENSE_CATEGORY_LOADING`;
export const DELETE_EXPENSE_CATEGORY_SUCCESS = `DELETE_EXPENSE_CATEGORY_SUCCESS`;
export const DELETE_EXPENSE_CATEGORY_ERROR = `DELETE_EXPENSE_CATEGORY_ERROR`;
export const DELETE_EXPENSE_CATEGORY_FROM_EVENT_STREAM = `DELETE_EXPENSE_CATEGORY_FROM_EVENT_STREAM`;

// AVAILABILITY TYPES
export const ADD_AVAILABILITY_TYPE_LOADING = `ADD_AVAILABILITY_TYPE_LOADING`;
export const ADD_AVAILABILITY_TYPE_SUCCESS = `ADD_AVAILABILITY_TYPE_SUCCESS`;
export const ADD_AVAILABILITY_TYPE_ERROR = `ADD_AVAILABILITY_TYPE_ERROR`;
export const EDIT_AVAILABILITY_TYPE_LOADING = `EDIT_AVAILABILITY_TYPE_LOADING`;
export const EDIT_AVAILABILITY_TYPE_SUCCESS = `EDIT_AVAILABILITY_TYPE_SUCCESS`;
export const EDIT_AVAILABILITY_TYPE_ERROR = `EDIT_AVAILABILITY_TYPE_ERROR`;
export const DELETE_AVAILABILITY_TYPE_LOADING = `DELETE_AVAILABILITY_TYPE_LOADING`;
export const DELETE_AVAILABILITY_TYPE_SUCCESS = `DELETE_AVAILABILITY_TYPE_SUCCESS`;
export const DELETE_AVAILABILITY_TYPE_ERROR = `DELETE_AVAILABILITY_TYPE_ERROR`;
export const FETCH_AVAILABILITY_TYPES_LOADING = `FETCH_AVAILABILITY_TYPES_LOADING`;
export const FETCH_AVAILABILITY_TYPES_SUCCESS = `FETCH_AVAILABILITY_TYPES_SUCCESS`;
export const FETCH_AVAILABILITY_TYPES_ERROR = `FETCH_AVAILABILITY_TYPES_ERROR`;
export const ADD_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS = `ADD_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS`;
export const EDIT_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS = `EDIT_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS`;
export const DELETE_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS = `DELETE_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS`;

// AVAILABILITY RECORDS
export const ADD_AVAILABILITY_RECORD_LOADING = `ADD_AVAILABILITY_RECORD_LOADING`;
export const ADD_AVAILABILITY_RECORD_SUCCESS = `ADD_AVAILABILITY_RECORD_SUCCESS`;
export const ADD_AVAILABILITY_RECORD_ERROR = `ADD_AVAILABILITY_RECORD_ERROR`;
export const DELETE_AVAILABILITY_RECORD_LOADING = `DELETE_AVAILABILITY_RECORD_LOADING`;
export const DELETE_AVAILABILITY_RECORD_SUCCESS = `DELETE_AVAILABILITY_RECORD_SUCCESS`;
export const DELETE_AVAILABILITY_RECORD_ERROR = `DELETE_AVAILABILITY_RECORD_ERROR`;
export const FETCH_AVAILABILITY_RECORDS_LOADING = `FETCH_AVAILABILITY_RECORDS_LOADING`;
export const FETCH_AVAILABILITY_RECORDS_SUCCESS = `FETCH_AVAILABILITY_RECORDS_SUCCESS`;
export const FETCH_AVAILABILITY_RECORDS_ERROR = `FETCH_AVAILABILITY_RECORDS_ERROR`;

export const ADD_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS = `ADD_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS`;
export const EDIT_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS = `EDIT_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS`;
export const DELETE_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS = `DELETE_AVAILABILITY_RECORD_FROM_EVENT_STREAM_SUCCESS`;

// FEATURE POINTERS
export const FETCH_FEATURE_POINTERS_LOADING = `FETCH_FEATURE_POINTERS_LOADING`;
export const FETCH_FEATURE_POINTERS_SUCCESS = `FETCH_FEATURE_POINTERS_SUCCESS`;
export const FETCH_FEATURE_POINTERS_ERROR = `FETCH_FEATURE_POINTERS_ERROR`;
export const DISMISS_FEATURE_POINTER_LOADING = `DISMISS_FEATURE_POINTER_LOADING`;
export const DISMISS_FEATURE_POINTER_SUCCESS = `DISMISS_FEATURE_POINTER_SUCCESS`;
export const DISMISS_FEATURE_POINTER_ERROR = `DISMISS_FEATURE_POINTER_ERROR`;

// SYSTEM NOTIFICATIONS
export const DELETE_SYSTEM_NOTIFICATION_ERROR = `DELETE_SYSTEM_NOTIFICATION_ERROR`;
export const DELETE_SYSTEM_NOTIFICATION_LOADING = `DELETE_SYSTEM_NOTIFICATION_LOADING`;
export const DELETE_SYSTEM_NOTIFICATION_SUCCESS = `DELETE_SYSTEM_NOTIFICATION_SUCCESS`;

// INTERNAL USER RATES
export const FETCH_ALL_INTERNAL_RATES_LOADING = `FETCH_ALL_INTERNAL_RATES_LOADING`;
export const FETCH_ALL_INTERNAL_RATES_SUCCESS = `FETCH_ALL_INTERNAL_RATES_SUCCESS`;
export const FETCH_ALL_INTERNAL_RATES_ERROR = `FETCH_ALL_INTERNAL_RATES_ERROR`;

// USER WORK WEEKS
export const FETCH_USER_WORKWEEK_LOADING = `FETCH_USER_WORKWEEK_LOADING`;
export const FETCH_USER_WORKWEEK_SUCCESS = `FETCH_USER_WORKWEEK_SUCCESS`;
export const FETCH_USER_WORKWEEK_ERROR = `FETCH_USER_WORKWEEK_ERROR`;
export const EDIT_USER_WORKWEEK_LOADING = `EDIT_USER_WORKWEEK_LOADING`;
export const EDIT_USER_WORKWEEK_SUCCESS = `EDIT_USER_WORKWEEK_SUCCESS`;
export const EDIT_USER_WORKWEEK_ERROR = `EDIT_USER_WORKWEEK_ERROR`;

export const UPDATE_USER_INTERNAL_RATE_LOADING = `UPDATE_USER_INTERNAL_RATE_LOADING`;
export const UPDATE_USER_INTERNAL_RATE_SUCCESS = `UPDATE_USER_INTERNAL_RATE_SUCCESS`;
export const UPDATE_USER_INTERNAL_RATE_ERROR = `UPDATE_USER_INTERNAL_RATE_ERROR`;

export const ADD_USER_INTERNAL_RATE_LOADING = `ADD_USER_INTERNAL_RATE_LOADING`;
export const ADD_USER_INTERNAL_RATE_SUCCESS = `ADD_USER_INTERNAL_RATE_SUCCESS`;
export const ADD_USER_INTERNAL_RATE_ERROR = `ADD_USER_INTERNAL_RATE_ERROR`;

export const DELETE_USER_INTERNAL_RATE_LOADING = `DELETE_USER_INTERNAL_RATE_LOADING`;
export const DELETE_USER_INTERNAL_RATE_SUCCESS = `DELETE_USER_INTERNAL_RATE_SUCCESS`;
export const DELETE_USER_INTERNAL_RATE_ERROR = `DELETE_USER_INTERNAL_RATE_ERROR`;

// UPDATE SUBSCRIBERS
export const UPDATE_SUBSCRIBERS_LOADING = "UPDATE_SUBSCRIBERS_LOADING";
export const UPDATE_SUBSCRIBERS_SUCCESS = "UPDATE_SUBSCRIBERS_SUCCESS ";
export const UPDATE_SUBSCRIBERS_ERROR = "UPDATE_SUBSCRIBERS_ERROR";

export const FETCH_BRAKE_DOWN_PRICE_LOADING = "FETCH_BRAKE_DOWN_PRICE_LOADING";
export const FETCH_BRAKE_DOWN_PRICE_SUCCESS = "FETCH_BRAKE_DOWN_PRICE_SUCCESS";
export const FETCH_BRAKE_DOWN_PRICE_ERROR = "FETCH_BRAKE_DOWN_PRICE_ERROR";

export const ADD_SUBSCRIBER_LOADING = "ADD_SUBSCRIBER_LOADING";
export const ADD_SUBSCRIBER_SUCCESS = "ADD_SUBSCRIBER_SUCCESS";
export const ADD_SUBSCRIBER_ERROR = "ADD_SUBSCRIBER_ERROR";

export const REMOVE_SUBSCRIBER_LOADING = "REMOVE_SUBSCRIBER_LOADING";
export const REMOVE_SUBSCRIBER_SUCCESS = "REMOVE_SUBSCRIBER_SUCCESS";
export const REMOVE_SUBSCRIBER_ERROR = "REMOVE_SUBSCRIBER_ERROR";

// PROJECT CATEGORIES
export const ANGULAR_INIT_PROJECT_CATEGORIES = `ANGULAR_INIT_PROJECT_CATEGORIES`;
export const ADD_PROJECT_CATEGORY_LOADING = `ADD_PROJECT_CATEGORY_LOADING`;
export const ADD_PROJECT_CATEGORY_SUCCESS = `ADD_PROJECT_CATEGORY_SUCCES`;
export const ADD_PROJECT_CATEGORY_ERROR = `ADD_PROJECT_CATEGORY_ERROR`;
export const DELETE_PROJECT_CATEGORY_LOADING = `DELETE_PROJECT_CATEGORY_LOADING`;
export const DELETE_PROJECT_CATEGORY_SUCCESS = `DELETE_PROJECT_CATEGORY_SUCCESS`;
export const DELETE_PROJECT_CATEGORY_ERROR = `DELETE_PROJECT_CATEGORY_ERROR`;
export const EDIT_PROJECT_CATEGORY_LOADING = `EDIT_PROJECT_CATEGORY_LOADING`;
export const EDIT_PROJECT_CATEGORY_SUCCESS = `EDIT_PROJECT_CATEGORY_SUCCESS`;
export const EDIT_PROJECT_CATEGORY_ERROR = `EDIT_PROJECT_CATEGORY_ERROR`;

// REMINDERS
export const ADD_REMINDER_LOADING = `ADD_REMINDER_LOADING`;
export const ADD_REMINDER_SUCCESS = `ADD_REMINDER_SUCCESS`;
export const ADD_REMINDER_ERROR = `ADD_REMINDER_ERROR`;
export const EDIT_REMINDER_LOADING = `EDIT_REMINDER_LOADING`;
export const EDIT_REMINDER_SUCCESS = `EDIT_REMINDER_SUCCESS`;
export const EDIT_REMINDER_ERROR = `EDIT_REMINDER_ERROR`;
export const DELETE_REMINDER_LOADING = `DELETE_REMINDER_LOADING`;
export const DELETE_REMINDER_SUCCESS = `DELETE_REMINDER_SUCCESS`;
export const DELETE_REMINDER_ERROR = `DELETE_REMINDER_ERROR`;
export const FETCH_REMINDERS_LOADING = `FETCH_REMINDERS_LOADING`;
export const FETCH_REMINDERS_SUCCESS = `FETCH_REMINDERS_SUCCESS`;
export const FETCH_REMINDERS_ERROR = `FETCH_REMINDERS_ERROR`;
export const ADD_REMINDER_FROM_EVENT_STREAM = "ADD_REMINDER_FROM_EVENT_STREAM";
export const UPDATE_REMINDER_FROM_EVENT_STREAM = "UPDATE_REMINDER_FROM_EVENT_STREAM";
export const DELETE_REMINDER_FROM_EVENT_STREAM = "DELETE_REMINDER_FROM_EVENT_STREAM";

// FAVORITES
export const ADD_FAVORITE_LOADING = "ADD_FAVORITE_LOADING";
export const ADD_FAVORITE_SUCCESS = "ADD_FAVORITE_SUCCESS";
export const ADD_FAVORITE_ERROR = "ADD_FAVORITE_ERROR";
export const REMOVE_FAVORITE_LOADING = "REMOVE_FAVORITE_LOADING";
export const REMOVE_FAVORITE_SUCCESS = "REMOVE_FAVORITE_SUCCESS";
export const REMOVE_FAVORITE_ERROR = "REMOVE_FAVORITE_ERROR";

// ACTIVITY LOGS
export const FETCH_ACTIVITY_LOGS_LOADING = "FETCH_ACTIVITY_LOGS_LOADING";
export const FETCH_ACTIVITY_LOGS_SUCCESS = "FETCH_ACTIVITY_LOGS_SUCCESS";
export const FETCH_ACTIVITY_LOGS_ERROR = "FETCH_ACTIVITY_LOGS_ERROR";

// STORAGE OVERUSED ERROR
export const STORAGE_OVERUSED_ERROR = "STORAGE_OVERUSED_ERROR";

// CONVERSATIONS
export const FETCH_CONVERSATIONS_LOADING = "FETCH_CONVERSATIONS_LOADING";
export const FETCH_CONVERSATIONS_SUCCESS = "FETCH_CONVERSATIONS_SUCCESS";
export const FETCH_CONVERSATIONS_ERROR = "FETCH_CONVERSATIONS_ERROR";
export const FETCH_CONVERSATION_LOADING = "FETCH_CONVERSATION_LOADING";
export const FETCH_CONVERSATION_SUCCESS = "FETCH_CONVERSATION_SUCCESS";
export const FETCH_CONVERSATION_ERROR = "FETCH_CONVERSATION_ERROR";
export const ADD_CONVERSATION_LOADING = "ADD_CONVERSATION_LOADING";
export const ADD_CONVERSATION_SUCCESS = "ADD_CONVERSATION_SUCCESS";
export const ADD_CONVERSATION_ERROR = "ADD_CONVERSATION_ERROR";
export const EDIT_CONVERSATION_LOADING = "EDIT_CONVERSATION_LOADING";
export const EDIT_CONVERSATION_SUCCESS = "EDIT_CONVERSATION_SUCCESS";
export const EDIT_CONVERSATION_ERROR = "EDIT_CONVERSATION_ERROR";
export const DELETE_CONVERSATION_LOADING = "DELETE_CONVERSATION_LOADING";
export const DELETE_CONVERSATION_SUCCESS = "DELETE_CONVERSATION_SUCCESS";
export const DELETE_CONVERSATION_ERROR = "DELETE_CONVERSATION_ERROR";
export const DELETE_CONVERSATION_FROM_EVENT_STREAM = "DELETE_CONVERSATION_FROM_EVENT_STREAM";
export const ADD_CONVERSATION_FROM_EVENT_STREAM = "ADD_CONVERSATION_FROM_EVENT_STREAM";
export const EDIT_CONVERSATION_FROM_EVENT_STREAM = "EDIT_CONVERSATION_FROM_EVENT_STREAM";
export const MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM = "MANAGE_CONVERSATION_USER_FROM_EVENT_STREAM";
export const LEAVE_CONVERSATION_LOADING = "LEAVE_CONVERSATION_LOADING";
export const LEAVE_CONVERSATION_SUCCESS = "LEAVE_CONVERSATION_SUCCESS";
export const LEAVE_CONVERSATION_ERROR = "LEAVE_CONVERSATION_ERROR";
export const INVITE_USER_CONVERSATION_LOADING = "INVITE_USER_CONVERSATION_LOADING";
export const INVITE_USER_CONVERSATION_SUCCESS = "INVITE_USER_CONVERSATION_SUCCESS";
export const INVITE_USER_CONVERSATION_ERROR = "INVITE_USER_CONVERSATION_ERROR";
export const ADD_CONVERSATION_ADMIN_LOADING = "ADD_CONVERSATION_ADMIN_LOADING";
export const ADD_CONVERSATION_ADMIN_SUCCESS = "ADD_CONVERSATION_ADMIN_SUCCESS";
export const ADD_CONVERSATION_ADMIN_ERROR = "ADD_CONVERSATION_ADMIN_ERROR";
export const REMOVE_CONVERSATION_ADMIN_LOADING = "REMOVE_CONVERSATION_ADMIN_LOADING";
export const REMOVE_CONVERSATION_ADMIN_SUCCESS = "REMOVE_CONVERSATION_ADMIN_SUCCESS";
export const REMOVE_CONVERSATION_ADMIN_ERROR = "REMOVE_CONVERSATION_ADMIN_ERROR";
export const REMOVE_CONVERSATION_PARTICIPANT_LOADING = "REMOVE_CONVERSATION_PARTICIPANT_LOADING";
export const REMOVE_CONVERSATION_PARTICIPANT_SUCCESS = "REMOVE_CONVERSATION_PARTICIPANT_SUCCESS";
export const REMOVE_CONVERSATION_PARTICIPANT_ERROR = "REMOVE_CONVERSATION_PARTICIPANT_ERROR";

// USER CONVERSATIONS
export const FETCH_USER_CONVERSATIONS_LOADING = "FETCH_USER_CONVERSATIONS_LOADING";
export const FETCH_USER_CONVERSATIONS_SUCCESS = "FETCH_USER_CONVERSATIONS_SUCCESS";
export const FETCH_USER_CONVERSATIONS_ERROR = "FETCH_USER_CONVERSATIONS_ERROR";
export const EDIT_USER_CONVERSATION_LOADING = "EDIT_USER_CONVERSATION_LOADING";
export const EDIT_USER_CONVERSATION_SUCCESS = "EDIT_USER_CONVERSATION_SUCCESS";
export const EDIT_USER_CONVERSATION_ERROR = "EDIT_USER_CONVERSATION_ERROR";
export const DELETE_CONVERSATION_USER_FROM_EVENT_STREAM = "DELETE_CONVERSATION_USER_FROM_EVENT_STREAM";

// CONVERSATION_MESSAGES
export const FETCH_CONVERSATION_MESSAGES_LOADING = "FETCH_CONVERSATION_MESSAGES_LOADING";
export const FETCH_CONVERSATION_MESSAGES_SUCCESS = "FETCH_CONVERSATION_MESSAGES_SUCCESS";
export const FETCH_CONVERSATION_MESSAGES_ERROR = "FETCH_CONVERSATION_MESSAGES_ERROR";
export const FETCH_CONVERSATION_MESSAGE_LOADING = "FETCH_CONVERSATION_MESSAGE_LOADING";
export const FETCH_CONVERSATION_MESSAGE_SUCCESS = "FETCH_CONVERSATION_MESSAGE_SUCCESS";
export const FETCH_CONVERSATION_MESSAGE_ERROR = "FETCH_CONVERSATION_MESSAGE_ERROR";
export const ADD_CONVERSATION_MESSAGE_LOADING = "ADD_CONVERSATION_MESSAGE_LOADING";
export const ADD_CONVERSATION_MESSAGE_SUCCESS = "ADD_CONVERSATION_MESSAGE_SUCCESS";
export const ADD_CONVERSATION_MESSAGE_ERROR = "ADD_CONVERSATION_MESSAGE_ERROR";
export const ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM = "ADD_CONVERSATION_MESSAGE_FROM_EVENT_STREAM";
export const DELETE_CONVERSATION_MESSAGE_LOADING = "DELETE_CONVERSATION_MESSAGE_LOADING";
export const DELETE_CONVERSATION_MESSAGE_SUCCESS = "DELETE_CONVERSATION_MESSAGE_SUCCESS";
export const DELETE_CONVERSATION_MESSAGE_ERROR = "DELETE_CONVERSATION_MESSAGE_ERROR";
export const DELETE_CONVERSATION_MESSAGE_FROM_EVENT_STREAM_SUCCESS =
  "DELETE_CONVERSATION_MESSAGE_FROM_EVENT_STREAM_SUCCESS";
export const EDIT_CONVERSATION_MESSAGE_LOADING = "EDIT_CONVERSATION_MESSAGE_LOADING";
export const EDIT_CONVERSATION_MESSAGE_SUCCESS = "EDIT_CONVERSATION_MESSAGE_SUCCESS";
export const EDIT_CONVERSATION_MESSAGE_ERROR = "EDIT_CONVERSATION_MESSAGE_ERROR";
export const EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM = "EDIT_CONVERSATION_MESSAGE_FROM_EVENT_STREAM";
export const MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING = "MARK_CONVERSATION_MESSAGE_AS_UNREAD_LOADING";
export const MARK_CONVERSATION_MESSAGE_AS_UNREAD_SUCCESS = "MARK_CONVERSATION_MESSAGE_AS_UNREAD_SUCCESS";
export const MARK_CONVERSATION_MESSAGE_AS_UNREAD_ERROR = "MARK_CONVERSATION_MESSAGE_AS_UNREAD_ERROR";

export const LOGOUT_USER = "LOGOUT_USER";

//SHORTCUTS
export const FETCH_SHORTCUTS_LOADING = `FETCH_SHORTCUTS_LOADING`;
export const FETCH_SHORTCUTS_SUCCESS = `FETCH_SHORTCUTS_SUCCESS`;
export const FETCH_SHORTCUTS_ERROR = `FETCH_SHORTCUTS_ERROR`;
export const ADD_SHORTCUT_LOADING = `ADD_SHORTCUT_LOADING`;
export const ADD_SHORTCUT_SUCCESS = `ADD_SHORTCUT_SUCCESS`;
export const ADD_SHORTCUT_ERROR = `ADD_SHORTCUT_ERROR`;
export const DELETE_SHORTCUT_LOADING = `DELETE_SHORTCUT_LOADING`;
export const DELETE_SHORTCUT_SUCCESS = `DELETE_SHORTCUT_SUCCESS`;
export const DELETE_SHORTCUT_ERROR = `DELETE_SHORTCUT_ERROR`;
export const EDIT_SHORTCUT_LOADING = `EDIT_SHORTCUT_LOADING`;
export const EDIT_SHORTCUT_SUCCESS = `EDIT_SHORTCUT_SUCCESS`;
export const EDIT_SHORTCUT_ERROR = `EDIT_SHORTCUT_ERROR`;
export const BATCH_DELETE_SHORTCUTS_LOADING = `BATCH_DELETE_SHORTCUTS_LOADING`;
export const BATCH_DELETE_SHORTCUTS_SUCCESS = `BATCH_DELETE_SHORTCUTS_SUCCESS`;
export const BATCH_DELETE_SHORTCUTS_ERROR = `BATCH_DELETE_SHORTCUTS_ERROR`;
export const REORDER_SHORTCUTS_LOADING = `REORDER_SHORTCUTS_LOADING`;
export const REORDER_SHORTCUTS_SUCCESS = `REORDER_SHORTCUTS_SUCCESS`;
export const REORDER_SHORTCUTS_ERROR = `REORDER_SHORTCUTS_ERROR`;

// FOLDERS
export const FETCH_FOLDER_LOADING = `FETCH_FOLDER_LOADING`;
export const FETCH_FOLDER_SUCCESS = `FETCH_FOLDER_SUCCESS`;
export const FETCH_FOLDER_ERROR = `FETCH_FOLDER_ERROR`;
export const FETCH_FOLDERS_LOADING = `FETCH_FOLDERS_LOADING`;
export const FETCH_FOLDERS_SUCCESS = `FETCH_FOLDERS_SUCCESS`;
export const FETCH_FOLDERS_ERROR = `FETCH_FOLDERS_ERROR`;
export const ADD_FOLDER_LOADING = `ADD_FOLDER_LOADING`;
export const ADD_FOLDER_SUCCESS = `ADD_FOLDER_SUCCESS`;
export const ADD_FOLDER_ERROR = `ADD_FOLDER_ERROR`;
export const EDIT_FOLDER_LOADING = `EDIT_FOLDER_LOADING`;
export const EDIT_FOLDER_SUCCESS = `EDIT_FOLDER_SUCCESS`;
export const EDIT_FOLDER_ERROR = `EDIT_FOLDER_ERROR`;
export const MOVE_FOLDER_LOADING = `MOVE_FOLDER_LOADING`;
export const MOVE_FOLDER_SUCCESS = `MOVE_FOLDER_SUCCESS`;
export const MOVE_FOLDER_ERROR = `MOVE_FOLDER_ERROR`;

// FILES
export const FETCH_FILE_LOADING = `FETCH_FILE_LOADING`;
export const FETCH_FILE_SUCCESS = `FETCH_FILE_SUCCESS`;
export const FETCH_FILE_ERROR = `FETCH_FILE_ERROR`;
export const FETCH_FILES_LOADING = `FETCH_FILES_LOADING`;
export const FETCH_FILES_SUCCESS = `FETCH_FILES_SUCCESS`;
export const FETCH_FILES_ERROR = `FETCH_FILES_ERROR`;
export const ADD_FILES_LOADING = `ADD_FILES_LOADING`;
export const ADD_FILES_SUCCESS = `ADD_FILES_SUCCESS`;
export const ADD_FILES_ERROR = `ADD_FILES_ERROR`;
export const EDIT_FILE_LOADING = `EDIT_FILE_LOADING`;
export const EDIT_FILE_SUCCESS = `EDIT_FILE_SUCCESS`;
export const EDIT_FILE_ERROR = `EDIT_FILE_ERROR`;
export const MOVE_FILE_LOADING = `MOVE_FILE_LOADING`;
export const MOVE_FILE_SUCCESS = `MOVE_FILE_SUCCESS`;
export const MOVE_FILE_ERROR = `MOVE_FILE_ERROR`;
export const FETCH_FILES_AND_ATTACHMENTS_LOADING = `FETCH_FILES_AND_ATTACHMENTS_LOADING`;
export const FETCH_FILES_AND_ATTACHMENTS_SUCCESS = `FETCH_FILES_AND_ATTACHMENTS_SUCCESS`;
export const FETCH_FILES_AND_ATTACHMENTS_ERROR = `FETCH_FILES_AND_ATTACHMENTS_ERROR`;
export const FETCH_FILES_FILTERS_LOADING = `FETCH_FILES_FILTERS_LOADING`;
export const FETCH_FILES_FILTERS_SUCCESS = `FETCH_FILES_FILTERS_SUCCESS`;
export const FETCH_FILES_FILTERS_ERROR = `FETCH_FILES_FILTERS_ERROR`;

// ATTACHMENTS
export const FETCH_ATTACHMENT_LOADING = `FETCH_ATTACHMENT_LOADING`;
export const FETCH_ATTACHMENT_SUCCESS = `FETCH_ATTACHMENT_SUCCESS`;
export const FETCH_ATTACHMENT_ERROR = `FETCH_ATTACHMENT_ERROR`;
export const FETCH_ATTACHMENTS_LOADING = `FETCH_ATTACHMENTS_LOADING`;
export const FETCH_ATTACHMENTS_SUCCESS = `FETCH_ATTACHMENTS_SUCCESS`;
export const FETCH_ATTACHMENTS_ERROR = `FETCH_ATTACHMENTS_ERROR`;
export const DELETE_ATTACHMENT_LOADING = `DELETE_ATTACHMENT_LOADING`;
export const DELETE_ATTACHMENT_SUCCESS = `DELETE_ATTACHMENT_SUCCESS`;
export const DELETE_ATTACHMENT_ERROR = `DELETE_ATTACHMENT_ERROR`;
export const MOVE_ATTACHMENT_LOADING = `MOVE_ATTACHMENT_LOADING`;
export const MOVE_ATTACHMENT_SUCCESS = `MOVE_ATTACHMENT_SUCCESS`;
export const MOVE_ATTACHMENT_ERROR = `MOVE_ATTACHMENT_ERROR`;
export const EDIT_ATTACHMENT_LOADING = `EDIT_ATTACHMENT_LOADING`;
export const EDIT_ATTACHMENT_SUCCESS = `EDIT_ATTACHMENT_SUCCESS`;
export const EDIT_ATTACHMENT_ERROR = `EDIT_ATTACHMENT_ERROR`;

// LANGUAGES
export const FETCH_LANGUAGES_SUCCESS = `FETCH_LANGUAGES_SUCCESS`;
export const EDIT_SYSTEM_LANGUAGE_LOADING = `EDIT_SYSTEM_LANGUAGE_LOADING`;
export const EDIT_SYSTEM_LANGUAGE_SUCCESS = `EDIT_SYSTEM_LANGUAGE_SUCCESS`;
export const EDIT_SYSTEM_LANGUAGE_ERROR = `EDIT_SYSTEM_LANGUAGE_ERROR`;

//CURRENCIES
export const EDIT_DEFAULT_CURRENCY_LOADING = `EDIT_DEFAULT_CURRENCY_LOADING`;
export const EDIT_DEFAULT_CURRENCY_SUCCESS = `EDIT_DEFAULT_CURRENCY_SUCCESS`;
export const EDIT_DEFAULT_CURRENCY_ERROR = `EDIT_DEFAULT_CURRENCY_ERROR`;

//CALENDAR EVENTS
export const FETCH_CALENDAR_EVENT_LOADING = "FETCH_CALENDAR_EVENT_LOADING";
export const FETCH_CALENDAR_EVENT_SUCCESS = "FETCH_CALENDAR_EVENT_SUCCESS";
export const FETCH_CALENDAR_EVENT_ERROR = "FETCH_CALENDAR_EVENT_ERROR";
export const PREFETCH_CALENDAR_EVENT_LOADING = "PREFETCH_CALENDAR_EVENT_LOADING";
export const PREFETCH_CALENDAR_EVENT_SUCCESS = "PREFETCH_CALENDAR_EVENT_SUCCESS";
export const PREFETCH_CALENDAR_EVENT_ERROR = "PREFETCH_CALENDAR_EVENT_ERROR";
export const ADD_CALENDAR_EVENT_LOADING = "ADD_CALENDAR_EVENT_LOADING";
export const ADD_CALENDAR_EVENT_SUCCESS = "ADD_CALENDAR_EVENT_SUCCESS";
export const ADD_CALENDAR_EVENT_ERROR = "ADD_CALENDAR_EVENT_ERROR";
export const EDIT_CALENDAR_EVENT_LOADING = "EDIT_CALENDAR_EVENT_LOADING";
export const EDIT_CALENDAR_EVENT_SUCCESS = "EDIT_CALENDAR_EVENT_SUCCESS";
export const EDIT_CALENDAR_EVENT_ERROR = "EDIT_CALENDAR_EVENT_ERROR";
export const MOVE_CALENDAR_EVENT_TO_TRASH_LOADING = `MOVE_CALENDAR_EVENT_TO_TRASH_LOADING`;
export const MOVE_CALENDAR_EVENT_TO_TRASH_SUCCESS = `MOVE_CALENDAR_EVENT_TO_TRASH_SUCCESS`;
export const MOVE_CALENDAR_EVENT_TO_TRASH_ERROR = `MOVE_CALENDAR_EVENT_TO_TRASH_ERROR`;
export const RESTORED_CALENDAR_EVENT_FROM_TRASH_LOADING = `RESTORED_CALENDAR_EVENT_FROM_TRASH_LOADING`;
export const RESTORED_CALENDAR_EVENT_FROM_TRASH_SUCCESS = `RESTORED_CALENDAR_EVENT_FROM_TRASH_SUCCESS`;
export const RESTORED_CALENDAR_EVENT_FROM_TRASH_ERROR = `RESTORED_CALENDAR_EVENT_FROM_TRASH_ERROR`;
export const DELETE_CALENDAR_EVENT_LOADING = "DELETE_CALENDAR_EVENT_LOADING";
export const DELETE_CALENDAR_EVENT_SUCCESS = "DELETE_CALENDAR_EVENT_SUCCESS";
export const DELETE_CALENDAR_EVENT_ERROR = "DELETE_CALENDAR_EVENT_ERROR";
export const DELETE_CALENDAR_EVENT_FROM_EVENT_STREAM = "DELETE_CALENDAR_EVENT_FROM_EVENT_STREAM";
export const SET_CALENDAR_EVENT_FROM_EVENT_STREAM = "SET_CALENDAR_EVENT_FROM_EVENT_STREAM";
export const RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_LOADING = "RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_LOADING";
export const RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_SUCCESS = "RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_SUCCESS";
export const RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_ERROR = "RESCHEDULE_ONLY_THIS_CALENDAR_EVENT_ERROR";
export const RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_LOADING = "RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_LOADING";
export const RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_SUCCESS = "RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_SUCCESS";
export const RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_ERROR = "RESCHEDULE_THIS_AND_FUTURE_CALENDAR_EVENTS_ERROR";
export const RESCHEDULE_ALL_CALENDAR_EVENTS_LOADING = "RESCHEDULE_ALL_CALENDAR_EVENTS_LOADING";
export const RESCHEDULE_ALL_CALENDAR_EVENTS_SUCCESS = "RESCHEDULE_ALL_CALENDAR_EVENTS_SUCCESS";
export const RESCHEDULE_ALL_CALENDAR_EVENTS_ERROR = "RESCHEDULE_ALL_CALENDAR_EVENTS_ERROR";
export const RESCHEDULE_EXCEPTION_CALENDAR_EVENT_LOADING = "RESCHEDULE_EXCEPTION_CALENDAR_EVENT_LOADING";
export const RESCHEDULE_EXCEPTION_CALENDAR_EVENT_SUCCESS = "RESCHEDULE_EXCEPTION_CALENDAR_EVENT_SUCCESS";
export const RESCHEDULE_EXCEPTION_CALENDAR_EVENT_ERROR = "RESCHEDULE_EXCEPTION_CALENDAR_EVENT_ERROR";
export const ADD_CALENDAR_EVENT_EXCLUDED_DATES_LOADING = "ADD_CALENDAR_EVENT_EXCLUDED_DATES_LOADING";
export const ADD_CALENDAR_EVENT_EXCLUDED_DATES_SUCCESS = "ADD_CALENDAR_EVENT_EXCLUDED_DATES_SUCCESS";
export const ADD_CALENDAR_EVENT_EXCLUDED_DATES_ERROR = "ADD_CALENDAR_EVENT_EXCLUDED_DATES_ERROR";

//CALENDARS
export const FETCH_CALENDAR_LOADING = `FETCH_CALENDAR_LOADING`;
export const FETCH_CALENDAR_SUCCESS = `FETCH_CALENDAR_SUCCESS`;
export const FETCH_CALENDAR_ERROR = `FETCH_CALENDAR_ERROR`;
export const FETCH_CALENDARS_LOADING = `FETCH_CALENDARS_LOADING`;
export const FETCH_CALENDARS_SUCCESS = `FETCH_CALENDARS_SUCCESS`;
export const FETCH_CALENDARS_ERROR = `FETCH_CALENDARS_ERROR`;
export const ADD_CALENDAR_LOADING = `ADD_CALENDAR_LOADING`;
export const ADD_CALENDAR_SUCCESS = `ADD_CALENDAR_SUCCESS`;
export const ADD_CALENDAR_ERROR = `ADD_CALENDAR_ERROR`;
export const ADD_EXTERNAL_CALENDAR_LOADING = `ADD_EXTERNAL_CALENDAR_LOADING`;
export const ADD_EXTERNAL_CALENDAR_SUCCESS = `ADD_EXTERNAL_CALENDAR_SUCCESS`;
export const ADD_EXTERNAL_CALENDAR_ERROR = `ADD_EXTERNAL_CALENDAR_ERROR`;
export const EDIT_CALENDAR_LOADING = `EDIT_CALENDAR_LOADING`;
export const EDIT_CALENDAR_SUCCESS = `EDIT_CALENDAR_SUCCESS`;
export const EDIT_CALENDAR_ERROR = `EDIT_CALENDAR_ERROR`;
export const MOVE_CALENDAR_TO_TRASH_LOADING = `MOVE_CALENDAR_TO_TRASH_LOADING`;
export const MOVE_CALENDAR_TO_TRASH_SUCCESS = `MOVE_CALENDAR_TO_TRASH_SUCCESS`;
export const MOVE_CALENDAR_TO_TRASH_ERROR = `MOVE_CALENDAR_TO_TRASH_ERROR`;
export const RESTORED_CALENDAR_FROM_TRASH_LOADING = `RESTORED_CALENDAR_FROM_TRASH_LOADING`;
export const RESTORED_CALENDAR_FROM_TRASH_SUCCESS = `RESTORED_CALENDAR_FROM_TRASH_SUCCESS`;
export const RESTORED_CALENDAR_FROM_TRASH_ERROR = `RESTORED_CALENDAR_FROM_TRASH_ERROR`;
export const MOVE_CALENDAR_EVENTS_TO_TRASH_FROM_EVENT_STREAM_BY_CALENDAR_ID = `MOVE_CALENDAR_EVENTS_TO_TRASH_FROM_EVENT_STREAM_BY_CALENDAR_ID`;
export const DELETE_CALENDAR_LOADING = "DELETE_CALENDAR_LOADING";
export const DELETE_CALENDAR_SUCCESS = "DELETE_CALENDAR_SUCCESS";
export const DELETE_CALENDAR_ERROR = "DELETE_CALENDAR_ERROR";
export const SET_CALENDAR_FROM_EVENT_STREAM = `SET_CALENDAR_FROM_EVENT_STREAM`;
export const LOAD_CALENDARS = `LOAD_CALENDARS`;
export const DELETE_CALENDAR_FROM_EVENT_STREAM = `DELETE_CALENDAR_FROM_EVENT_STREAM`;
export const FETCH_CALENDAR_ASSIGMENTS_LOADING = `FETCH_CALENDAR_ASSIGMENTS_LOADING`;
export const FETCH_CALENDAR_ASSIGMENTS_SUCCESS = `FETCH_CALENDAR_ASSIGMENTS_SUCCESS`;
export const FETCH_CALENDAR_ASSIGMENTS_ERROR = `FETCH_CALENDAR_ASSIGMENTS_ERROR`;
export const REFRESH_EXTERNAL_CALENDAR_LOADING = `REFRESH_EXTERNAL_CALENDAR_LOADING`;
export const REFRESH_EXTERNAL_CALENDAR_SUCCESS = `REFRESH_EXTERNAL_CALENDAR_SUCCESS`;
export const REFRESH_EXTERNAL_CALENDAR_ERROR = `REFRESH_EXTERNAL_CALENDAR_ERROR`;
